/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';
import { AppConfigService } from '../services/app-config.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IApiKeyServiceProxy {
  /**
   * @param body (optional)
   * @return Success
   */
  requestApiKey(body: HardwareInformation | undefined): Observable<string>;
  /**
   * @param clientServerId (optional)
   * @return Success
   */
  requestClientServer(clientServerId: number | undefined): Observable<string>;
}

@Injectable()
export class ApiKeyServiceProxy implements IApiKeyServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param body (optional)
   * @return Success
   */
  requestApiKey(body: HardwareInformation | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/ApiKey/requestApiKey';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestApiKey(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestApiKey(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestApiKey(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * @param clientServerId (optional)
   * @return Success
   */
  requestClientServer(clientServerId: number | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/ApiKey/requestClientServer?';
    if (clientServerId === null) throw new Error("The parameter 'clientServerId' cannot be null.");
    else if (clientServerId !== undefined) url_ += 'clientServerId=' + encodeURIComponent('' + clientServerId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestClientServer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestClientServer(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestClientServer(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }
}

export interface IBankAccountServiceProxy {
  /**
   * @param businessId (optional)
   * @param user (optional)
   * @return Success
   */
  bankAccount(businessId: number | undefined, user: string | null | undefined): Observable<BankAccount[]>;
  /**
   * @return Success
   */
  types(): Observable<Int64StringKeyValuePair[]>;
}

@Injectable()
export class BankAccountServiceProxy implements IBankAccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param businessId (optional)
   * @param user (optional)
   * @return Success
   */
  bankAccount(businessId: number | undefined, user: string | null | undefined): Observable<BankAccount[]> {
    let url_ = this.baseUrl + '/api/BankAccount?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    if (user !== undefined && user !== null) url_ += 'user=' + encodeURIComponent('' + user) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBankAccount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBankAccount(<any>response_);
            } catch (e) {
              return <Observable<BankAccount[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<BankAccount[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBankAccount(response: HttpResponseBase): Observable<BankAccount[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BankAccount.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as BankAccount[]);
  }

  /**
   * @return Success
   */
  types(): Observable<Int64StringKeyValuePair[]> {
    let url_ = this.baseUrl + '/api/BankAccount/types';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTypes(<any>response_);
            } catch (e) {
              return <Observable<Int64StringKeyValuePair[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Int64StringKeyValuePair[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processTypes(response: HttpResponseBase): Observable<Int64StringKeyValuePair[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Int64StringKeyValuePair.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as Int64StringKeyValuePair[]);
  }
}

export interface IBankFeedsServiceProxy {
  /**
   * @param businessId (optional)
   * @return Success
   */
  init(businessId: number | undefined): Observable<InitialisationResponse>;
  /**
   * @return Success
   */
  institutions(): Observable<InitialisationResponse>;
  /**
   * @return Success
   */
  bankFeeds(): Observable<DeleteResponse>;
}

@Injectable()
export class BankFeedsServiceProxy implements IBankFeedsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  init(businessId: number | undefined): Observable<InitialisationResponse> {
    let url_ = this.baseUrl + '/api/BankFeeds/init?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInit(<any>response_);
            } catch (e) {
              return <Observable<InitialisationResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<InitialisationResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInit(response: HttpResponseBase): Observable<InitialisationResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InitialisationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InitialisationResponse>(<any>null);
  }

  /**
   * @return Success
   */
  institutions(): Observable<InitialisationResponse> {
    let url_ = this.baseUrl + '/api/BankFeeds/institutions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInstitutions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInstitutions(<any>response_);
            } catch (e) {
              return <Observable<InitialisationResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<InitialisationResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInstitutions(response: HttpResponseBase): Observable<InitialisationResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = InitialisationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<InitialisationResponse>(<any>null);
  }

  /**
   * @return Success
   */
  bankFeeds(): Observable<DeleteResponse> {
    let url_ = this.baseUrl + '/api/BankFeeds';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBankFeeds(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBankFeeds(<any>response_);
            } catch (e) {
              return <Observable<DeleteResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<DeleteResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBankFeeds(response: HttpResponseBase): Observable<DeleteResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DeleteResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<DeleteResponse>(<any>null);
  }
}

export interface IBusinessServiceProxy {
  /**
   * @param userName (optional)
   * @return Success
   */
  unlicensed(userName: string | null | undefined): Observable<Business[]>;
}

@Injectable()
export class BusinessServiceProxy implements IBusinessServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param userName (optional)
   * @return Success
   */
  unlicensed(userName: string | null | undefined): Observable<Business[]> {
    let url_ = this.baseUrl + '/api/Business/unlicensed?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnlicensed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnlicensed(<any>response_);
            } catch (e) {
              return <Observable<Business[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Business[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUnlicensed(response: HttpResponseBase): Observable<Business[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Business.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as Business[]);
  }
}

export interface IBusinessLookupServiceProxy {
  /**
   * @param abn (optional)
   * @return Success
   */
  abn(abn: string | null | undefined): Observable<BusinessNumberResponse>;
  /**
   * @param acn (optional)
   * @return Success
   */
  acn(acn: string | null | undefined): Observable<BusinessNumberResponse>;
}

@Injectable()
export class BusinessLookupServiceProxy implements IBusinessLookupServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param abn (optional)
   * @return Success
   */
  abn(abn: string | null | undefined): Observable<BusinessNumberResponse> {
    let url_ = this.baseUrl + '/api/BusinessLookup/abn?';
    if (abn !== undefined && abn !== null) url_ += 'abn=' + encodeURIComponent('' + abn) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAbn(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAbn(<any>response_);
            } catch (e) {
              return <Observable<BusinessNumberResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<BusinessNumberResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAbn(response: HttpResponseBase): Observable<BusinessNumberResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BusinessNumberResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BusinessNumberResponse>(<any>null);
  }

  /**
   * @param acn (optional)
   * @return Success
   */
  acn(acn: string | null | undefined): Observable<BusinessNumberResponse> {
    let url_ = this.baseUrl + '/api/BusinessLookup/acn?';
    if (acn !== undefined && acn !== null) url_ += 'acn=' + encodeURIComponent('' + acn) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAcn(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAcn(<any>response_);
            } catch (e) {
              return <Observable<BusinessNumberResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<BusinessNumberResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAcn(response: HttpResponseBase): Observable<BusinessNumberResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BusinessNumberResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BusinessNumberResponse>(<any>null);
  }
}

export interface IDocumentServiceProxy {
  /**
   * @param transactionId (optional)
   * @param documentType (optional)
   * @param path (optional)
   * @return Success
   */
  uploadTransactionDocument(transactionId: number | null | undefined, documentType: DocumentType | undefined, path: string | null | undefined): Observable<void>;
  /**
   * @param owner (optional)
   * @param documentType (optional)
   * @param path (optional)
   * @return Success
   */
  upload(owner: string | null | undefined, documentType: DocumentType | undefined, path: string | null | undefined): Observable<void>;
}

@Injectable()
export class DocumentServiceProxy implements IDocumentServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param transactionId (optional)
   * @param documentType (optional)
   * @param path (optional)
   * @return Success
   */
  uploadTransactionDocument(transactionId: number | null | undefined, documentType: DocumentType | undefined, path: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Document/uploadTransactionDocument?';
    if (transactionId !== undefined && transactionId !== null) url_ += 'transactionId=' + encodeURIComponent('' + transactionId) + '&';
    if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
    else if (documentType !== undefined) url_ += 'documentType=' + encodeURIComponent('' + documentType) + '&';
    if (path !== undefined && path !== null) url_ += 'path=' + encodeURIComponent('' + path) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadTransactionDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadTransactionDocument(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadTransactionDocument(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param owner (optional)
   * @param documentType (optional)
   * @param path (optional)
   * @return Success
   */
  upload(owner: string | null | undefined, documentType: DocumentType | undefined, path: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Document/upload?';
    if (owner !== undefined && owner !== null) url_ += 'owner=' + encodeURIComponent('' + owner) + '&';
    if (documentType === null) throw new Error("The parameter 'documentType' cannot be null.");
    else if (documentType !== undefined) url_ += 'documentType=' + encodeURIComponent('' + documentType) + '&';
    if (path !== undefined && path !== null) url_ += 'path=' + encodeURIComponent('' + path) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpload(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpload(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpload(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface IFileServiceProxy {
  download(
    folderName: string | null | undefined,
    user: string | null | undefined,
    fileType: BackupType | undefined,
    revisionDate: moment.Moment | null | undefined
  ): Observable<FileResponse>;
  downloadById(revisionId: number | undefined, user: string | null | undefined): Observable<FileResponse>;
  /**
   * @param owner (optional)
   * @param md5AsHex (optional)
   * @param file (optional)
   * @return Success
   */
  upload2(owner: string | null | undefined, md5AsHex: string | null | undefined, file: FileParameter | undefined): Observable<BackupFileDetails>;
  /**
   * @param owner (optional)
   * @param md5AsHex (optional)
   * @param subscriptionId (optional)
   * @param file (optional)
   * @return Success
   */
  uploadWithSubscription(
    owner: string | null | undefined,
    md5AsHex: string | null | undefined,
    subscriptionId: number | undefined,
    file: FileParameter | undefined
  ): Observable<BackupFileDetails>;
  /**
   * @param revisionId (optional)
   * @return Success
   */
  injectRevision(revisionId: number | undefined): Observable<void>;
  /**
   * @param folderName (optional)
   * @param owner (optional)
   * @param revisionDate (optional)
   * @param fileType (optional)
   * @return Success
   */
  restore(
    folderName: string | null | undefined,
    owner: string | null | undefined,
    revisionDate: moment.Moment | undefined,
    fileType: BackupType | undefined
  ): Observable<BackupFile>;
  /**
   * @param revisionId (optional)
   * @param owner (optional)
   * @return Success
   */
  restoreRevision(revisionId: number | undefined, owner: string | null | undefined): Observable<BackupFile>;
  /**
   * @param folderName (optional)
   * @param user (optional)
   * @param fileType (optional)
   * @return Success
   */
  file(folderName: string | null | undefined, user: string | null | undefined, fileType: BackupType | undefined): Observable<BackupFileDetails>;
  /**
   * @param folderName (optional)
   * @param user (optional)
   * @param fileType (optional)
   * @return Success
   */
  getLatestRevision(folderName: string | null | undefined, user: string | null | undefined, fileType: BackupType | undefined): Observable<string>;
  /**
   * @param fileTypes (optional)
   * @return Success
   */
  listAll(fileTypes: BackupType[] | null | undefined): Observable<BackupFile[]>;
  /**
   * @return Success
   */
  list(): Observable<BackupFileDetails[]>;
  /**
   * @param fileTypes (optional)
   * @return Success
   */
  deletedFileList(fileTypes: BackupType[] | null | undefined): Observable<BackupFile[]>;
  /**
   * @param fileName (optional)
   * @param fileType (optional)
   * @return Success
   */
  share(fileName: string | null | undefined, userNumber: string | null, permissions: SharingPermissions, fileType: BackupType | undefined): Observable<BackupFileDetails>;
  /**
   * @return Success
   */
  share2(grantId: number, permissions: SharingPermissions): Observable<BackupFileDetails>;
  /**
   * @return Success
   */
  share3(grantId: number): Observable<BackupFileDetails>;
  /**
   * @return Success
   */
  reject(grantId: number): Observable<void>;
  /**
   * @return Success
   */
  file2(businessId: number, fileType: BackupType): Observable<void>;
  /**
   * @param userName (optional)
   * @return Success
   */
  businessNames(userName: string | null | undefined): Observable<string[]>;
  /**
   * @param businessId (optional)
   * @param subscriptionId (optional)
   * @return Success
   */
  linkBusinessSubscription(businessId: number | undefined, subscriptionId: number | undefined): Observable<void>;
  /**
   * @param userName (optional)
   * @param businessName (optional)
   * @param subscriptionId (optional)
   * @param file (optional)
   * @return Success
   */
  deliverClientFile(
    userName: string | null | undefined,
    businessName: string | null | undefined,
    subscriptionId: number | undefined,
    file: FileParameter | null | undefined
  ): Observable<void>;
}

@Injectable()
export class FileServiceProxy implements IFileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  download(
    folderName: string | null | undefined,
    user: string | null | undefined,
    fileType: BackupType | undefined,
    revisionDate: moment.Moment | null | undefined
  ): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/File/download?';
    if (folderName !== undefined && folderName !== null) url_ += 'folderName=' + encodeURIComponent('' + folderName) + '&';
    if (user !== undefined && user !== null) url_ += 'user=' + encodeURIComponent('' + user) + '&';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    if (revisionDate !== undefined && revisionDate !== null) url_ += 'revisionDate=' + encodeURIComponent(revisionDate ? '' + revisionDate.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/octet-stream'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownload(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownload(<any>response_);
            } catch (e) {
              return <Observable<FileResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<FileResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(<any>null);
  }

  downloadById(revisionId: number | undefined, user: string | null | undefined): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/File/downloadById?';
    if (revisionId === null) throw new Error("The parameter 'revisionId' cannot be null.");
    else if (revisionId !== undefined) url_ += 'revisionId=' + encodeURIComponent('' + revisionId) + '&';
    if (user !== undefined && user !== null) url_ += 'user=' + encodeURIComponent('' + user) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/octet-stream'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadById(<any>response_);
            } catch (e) {
              return <Observable<FileResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<FileResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownloadById(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<FileResponse>(<any>null);
  }

  /**
   * @param owner (optional)
   * @param md5AsHex (optional)
   * @param file (optional)
   * @return Success
   */
  upload2(owner: string | null | undefined, md5AsHex: string | null | undefined, file: FileParameter | undefined): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File/upload?';
    if (owner !== undefined && owner !== null) url_ += 'owner=' + encodeURIComponent('' + owner) + '&';
    if (md5AsHex !== undefined && md5AsHex !== null) url_ += 'md5AsHex=' + encodeURIComponent('' + md5AsHex) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpload2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpload2(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpload2(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @param owner (optional)
   * @param md5AsHex (optional)
   * @param subscriptionId (optional)
   * @param file (optional)
   * @return Success
   */
  uploadWithSubscription(
    owner: string | null | undefined,
    md5AsHex: string | null | undefined,
    subscriptionId: number | undefined,
    file: FileParameter | undefined
  ): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File/uploadWithSubscription?';
    if (owner !== undefined && owner !== null) url_ += 'owner=' + encodeURIComponent('' + owner) + '&';
    if (md5AsHex !== undefined && md5AsHex !== null) url_ += 'md5AsHex=' + encodeURIComponent('' + md5AsHex) + '&';
    if (subscriptionId === null) throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined) url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadWithSubscription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadWithSubscription(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadWithSubscription(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @param revisionId (optional)
   * @return Success
   */
  injectRevision(revisionId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/File/injectRevision?';
    if (revisionId === null) throw new Error("The parameter 'revisionId' cannot be null.");
    else if (revisionId !== undefined) url_ += 'revisionId=' + encodeURIComponent('' + revisionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInjectRevision(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInjectRevision(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInjectRevision(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param folderName (optional)
   * @param owner (optional)
   * @param revisionDate (optional)
   * @param fileType (optional)
   * @return Success
   */
  restore(
    folderName: string | null | undefined,
    owner: string | null | undefined,
    revisionDate: moment.Moment | undefined,
    fileType: BackupType | undefined
  ): Observable<BackupFile> {
    let url_ = this.baseUrl + '/api/File/restore?';
    if (folderName !== undefined && folderName !== null) url_ += 'folderName=' + encodeURIComponent('' + folderName) + '&';
    if (owner !== undefined && owner !== null) url_ += 'owner=' + encodeURIComponent('' + owner) + '&';
    if (revisionDate === null) throw new Error("The parameter 'revisionDate' cannot be null.");
    else if (revisionDate !== undefined) url_ += 'revisionDate=' + encodeURIComponent(revisionDate ? '' + revisionDate.toJSON() : '') + '&';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRestore(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRestore(<any>response_);
            } catch (e) {
              return <Observable<BackupFile>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRestore(response: HttpResponseBase): Observable<BackupFile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFile>(<any>null);
  }

  /**
   * @param revisionId (optional)
   * @param owner (optional)
   * @return Success
   */
  restoreRevision(revisionId: number | undefined, owner: string | null | undefined): Observable<BackupFile> {
    let url_ = this.baseUrl + '/api/File/restoreRevision?';
    if (revisionId === null) throw new Error("The parameter 'revisionId' cannot be null.");
    else if (revisionId !== undefined) url_ += 'revisionId=' + encodeURIComponent('' + revisionId) + '&';
    if (owner !== undefined && owner !== null) url_ += 'owner=' + encodeURIComponent('' + owner) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRestoreRevision(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRestoreRevision(<any>response_);
            } catch (e) {
              return <Observable<BackupFile>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRestoreRevision(response: HttpResponseBase): Observable<BackupFile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFile>(<any>null);
  }

  /**
   * @param folderName (optional)
   * @param user (optional)
   * @param fileType (optional)
   * @return Success
   */
  file(folderName: string | null | undefined, user: string | null | undefined, fileType: BackupType | undefined): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File?';
    if (folderName !== undefined && folderName !== null) url_ += 'folderName=' + encodeURIComponent('' + folderName) + '&';
    if (user !== undefined && user !== null) url_ += 'user=' + encodeURIComponent('' + user) + '&';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFile(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processFile(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @param folderName (optional)
   * @param user (optional)
   * @param fileType (optional)
   * @return Success
   */
  getLatestRevision(folderName: string | null | undefined, user: string | null | undefined, fileType: BackupType | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/File/getLatestRevision?';
    if (folderName !== undefined && folderName !== null) url_ += 'folderName=' + encodeURIComponent('' + folderName) + '&';
    if (user !== undefined && user !== null) url_ += 'user=' + encodeURIComponent('' + user) + '&';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestRevision(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestRevision(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetLatestRevision(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * @param fileTypes (optional)
   * @return Success
   */
  listAll(fileTypes: BackupType[] | null | undefined): Observable<BackupFile[]> {
    let url_ = this.baseUrl + '/api/File/list?';
    if (fileTypes !== undefined && fileTypes !== null)
      fileTypes &&
        fileTypes.forEach((item) => {
          url_ += 'fileTypes=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListAll(<any>response_);
            } catch (e) {
              return <Observable<BackupFile[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFile[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processListAll(response: HttpResponseBase): Observable<BackupFile[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BackupFile.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as BackupFile[]);
  }

  /**
   * @return Success
   */
  list(): Observable<BackupFileDetails[]> {
    let url_ = this.baseUrl + '/api/File/v2/list';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processList(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processList(response: HttpResponseBase): Observable<BackupFileDetails[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BackupFileDetails.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as BackupFileDetails[]);
  }

  /**
   * @param fileTypes (optional)
   * @return Success
   */
  deletedFileList(fileTypes: BackupType[] | null | undefined): Observable<BackupFile[]> {
    let url_ = this.baseUrl + '/api/File/deletedFileList?';
    if (fileTypes !== undefined && fileTypes !== null)
      fileTypes &&
        fileTypes.forEach((item) => {
          url_ += 'fileTypes=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeletedFileList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeletedFileList(<any>response_);
            } catch (e) {
              return <Observable<BackupFile[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFile[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeletedFileList(response: HttpResponseBase): Observable<BackupFile[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BackupFile.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as BackupFile[]);
  }

  /**
   * @param fileName (optional)
   * @param fileType (optional)
   * @return Success
   */
  share(fileName: string | null | undefined, userNumber: string | null, permissions: SharingPermissions, fileType: BackupType | undefined): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File/share/{userNumber}/{permissions}?';
    if (userNumber === undefined || userNumber === null) throw new Error("The parameter 'userNumber' must be defined.");
    url_ = url_.replace('{userNumber}', encodeURIComponent('' + userNumber));
    if (permissions === undefined || permissions === null) throw new Error("The parameter 'permissions' must be defined.");
    url_ = url_.replace('{permissions}', encodeURIComponent('' + permissions));
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processShare(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processShare(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processShare(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @return Success
   */
  share2(grantId: number, permissions: SharingPermissions): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File/share/{grantId}/{permissions}';
    if (grantId === undefined || grantId === null) throw new Error("The parameter 'grantId' must be defined.");
    url_ = url_.replace('{grantId}', encodeURIComponent('' + grantId));
    if (permissions === undefined || permissions === null) throw new Error("The parameter 'permissions' must be defined.");
    url_ = url_.replace('{permissions}', encodeURIComponent('' + permissions));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processShare2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processShare2(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processShare2(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @return Success
   */
  share3(grantId: number): Observable<BackupFileDetails> {
    let url_ = this.baseUrl + '/api/File/share/{grantId}';
    if (grantId === undefined || grantId === null) throw new Error("The parameter 'grantId' must be defined.");
    url_ = url_.replace('{grantId}', encodeURIComponent('' + grantId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processShare3(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processShare3(<any>response_);
            } catch (e) {
              return <Observable<BackupFileDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<BackupFileDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processShare3(response: HttpResponseBase): Observable<BackupFileDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BackupFileDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BackupFileDetails>(<any>null);
  }

  /**
   * @return Success
   */
  reject(grantId: number): Observable<void> {
    let url_ = this.baseUrl + '/api/File/share/reject/{grantId}';
    if (grantId === undefined || grantId === null) throw new Error("The parameter 'grantId' must be defined.");
    url_ = url_.replace('{grantId}', encodeURIComponent('' + grantId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReject(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReject(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReject(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  file2(businessId: number, fileType: BackupType): Observable<void> {
    let url_ = this.baseUrl + '/api/File/{businessId}/{fileType}';
    if (businessId === undefined || businessId === null) throw new Error("The parameter 'businessId' must be defined.");
    url_ = url_.replace('{businessId}', encodeURIComponent('' + businessId));
    if (fileType === undefined || fileType === null) throw new Error("The parameter 'fileType' must be defined.");
    url_ = url_.replace('{fileType}', encodeURIComponent('' + fileType));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFile2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFile2(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processFile2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param userName (optional)
   * @return Success
   */
  businessNames(userName: string | null | undefined): Observable<string[]> {
    let url_ = this.baseUrl + '/api/File/businessNames?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBusinessNames(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBusinessNames(<any>response_);
            } catch (e) {
              return <Observable<string[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<string[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBusinessNames(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as string[]);
  }

  /**
   * @param businessId (optional)
   * @param subscriptionId (optional)
   * @return Success
   */
  linkBusinessSubscription(businessId: number | undefined, subscriptionId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/File/linkBusinessSubscription?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    if (subscriptionId === null) throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined) url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLinkBusinessSubscription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLinkBusinessSubscription(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processLinkBusinessSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param userName (optional)
   * @param businessName (optional)
   * @param subscriptionId (optional)
   * @param file (optional)
   * @return Success
   */
  deliverClientFile(
    userName: string | null | undefined,
    businessName: string | null | undefined,
    subscriptionId: number | undefined,
    file: FileParameter | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/File/deliverClientFile?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (businessName !== undefined && businessName !== null) url_ += 'businessName=' + encodeURIComponent('' + businessName) + '&';
    if (subscriptionId === null) throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined) url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined) content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeliverClientFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeliverClientFile(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeliverClientFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface IHelpCentreLinkServiceProxy {
  /**
   * @param area (optional)
   * @param name (optional)
   * @return Success
   */
  helpCentreLink(area: string | null | undefined, name: string | null | undefined): Observable<HelpLink>;
  /**
   * @param area (optional)
   * @return Success
   */
  area(area: string | null | undefined): Observable<HelpLink[]>;
}

@Injectable()
export class HelpCentreLinkServiceProxy implements IHelpCentreLinkServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param area (optional)
   * @param name (optional)
   * @return Success
   */
  helpCentreLink(area: string | null | undefined, name: string | null | undefined): Observable<HelpLink> {
    let url_ = this.baseUrl + '/api/HelpCentreLink?';
    if (area !== undefined && area !== null) url_ += 'area=' + encodeURIComponent('' + area) + '&';
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHelpCentreLink(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHelpCentreLink(<any>response_);
            } catch (e) {
              return <Observable<HelpLink>>(<any>_observableThrow(e));
            }
          } else return <Observable<HelpLink>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processHelpCentreLink(response: HttpResponseBase): Observable<HelpLink> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HelpLink.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<HelpLink>(<any>null);
  }

  /**
   * @param area (optional)
   * @return Success
   */
  area(area: string | null | undefined): Observable<HelpLink[]> {
    let url_ = this.baseUrl + '/api/HelpCentreLink/area?';
    if (area !== undefined && area !== null) url_ += 'area=' + encodeURIComponent('' + area) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processArea(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processArea(<any>response_);
            } catch (e) {
              return <Observable<HelpLink[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<HelpLink[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processArea(response: HttpResponseBase): Observable<HelpLink[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(HelpLink.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as HelpLink[]);
  }
}

export interface ILicensingServiceProxy {
  /**
   * @param softwareActivationKey (optional)
   * @param userNumber (optional)
   * @return Success
   */
  find(softwareActivationKey: string | null | undefined, userNumber: string | null | undefined): Observable<ClientActivationResponse>;
  /**
   * @param userNumber (optional)
   * @return Success
   */
  findLicense(userNumber: string | null | undefined): Observable<ClientLicenseResponse>;
  /**
   * @param userName (optional)
   * @param nodeId (optional)
   * @return Success
   */
  activate(userName: string | null | undefined, nodeId: string | null | undefined): Observable<ActivationResponse>;
  /**
   * @param softwareActivationKey (optional)
   * @return Success
   */
  revoke(softwareActivationKey: string | null | undefined): Observable<ClientLicenseResponse>;
  /**
   * @param userName (optional)
   * @param reactivation (optional)
   * @return Success
   */
  activationAllowed(userName: string | null | undefined, reactivation: boolean | undefined): Observable<ActivationAllowedResponse>;
  /**
   * @param userName (optional)
   * @param softwareActivationKey (optional)
   * @param manuallyActivated (optional)
   * @param reactivation (optional)
   * @return Success
   */
  saveActivation(
    userName: string | null | undefined,
    softwareActivationKey: string | null | undefined,
    manuallyActivated: boolean | undefined,
    reactivation: boolean | undefined
  ): Observable<ActivationAllowedResponse>;
  /**
   * @param activationKey (optional)
   * @param userName (optional)
   * @param body (optional)
   * @return Success
   */
  saveUserData(
    activationKey: string | null | undefined,
    userName: string | null | undefined,
    body: UserDatumModel[] | null | undefined
  ): Observable<ActivationAllowedResponse>;
}

@Injectable()
export class LicensingServiceProxy implements ILicensingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param softwareActivationKey (optional)
   * @param userNumber (optional)
   * @return Success
   */
  find(softwareActivationKey: string | null | undefined, userNumber: string | null | undefined): Observable<ClientActivationResponse> {
    let url_ = this.baseUrl + '/api/Licensing/find?';
    if (softwareActivationKey !== undefined && softwareActivationKey !== null) url_ += 'softwareActivationKey=' + encodeURIComponent('' + softwareActivationKey) + '&';
    if (userNumber !== undefined && userNumber !== null) url_ += 'userNumber=' + encodeURIComponent('' + userNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFind(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFind(<any>response_);
            } catch (e) {
              return <Observable<ClientActivationResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClientActivationResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processFind(response: HttpResponseBase): Observable<ClientActivationResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientActivationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClientActivationResponse>(<any>null);
  }

  /**
   * @param userNumber (optional)
   * @return Success
   */
  findLicense(userNumber: string | null | undefined): Observable<ClientLicenseResponse> {
    let url_ = this.baseUrl + '/api/Licensing/findLicense?';
    if (userNumber !== undefined && userNumber !== null) url_ += 'userNumber=' + encodeURIComponent('' + userNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindLicense(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindLicense(<any>response_);
            } catch (e) {
              return <Observable<ClientLicenseResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClientLicenseResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processFindLicense(response: HttpResponseBase): Observable<ClientLicenseResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientLicenseResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClientLicenseResponse>(<any>null);
  }

  /**
   * @param userName (optional)
   * @param nodeId (optional)
   * @return Success
   */
  activate(userName: string | null | undefined, nodeId: string | null | undefined): Observable<ActivationResponse> {
    let url_ = this.baseUrl + '/api/Licensing/activate?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (nodeId !== undefined && nodeId !== null) url_ += 'nodeId=' + encodeURIComponent('' + nodeId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(<any>response_);
            } catch (e) {
              return <Observable<ActivationResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ActivationResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<ActivationResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActivationResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActivationResponse>(<any>null);
  }

  /**
   * @param softwareActivationKey (optional)
   * @return Success
   */
  revoke(softwareActivationKey: string | null | undefined): Observable<ClientLicenseResponse> {
    let url_ = this.baseUrl + '/api/Licensing/revoke?';
    if (softwareActivationKey !== undefined && softwareActivationKey !== null) url_ += 'softwareActivationKey=' + encodeURIComponent('' + softwareActivationKey) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRevoke(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRevoke(<any>response_);
            } catch (e) {
              return <Observable<ClientLicenseResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ClientLicenseResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRevoke(response: HttpResponseBase): Observable<ClientLicenseResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ClientLicenseResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ClientLicenseResponse>(<any>null);
  }

  /**
   * @param userName (optional)
   * @param reactivation (optional)
   * @return Success
   */
  activationAllowed(userName: string | null | undefined, reactivation: boolean | undefined): Observable<ActivationAllowedResponse> {
    let url_ = this.baseUrl + '/api/Licensing/activationAllowed?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (reactivation === null) throw new Error("The parameter 'reactivation' cannot be null.");
    else if (reactivation !== undefined) url_ += 'reactivation=' + encodeURIComponent('' + reactivation) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivationAllowed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivationAllowed(<any>response_);
            } catch (e) {
              return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActivationAllowed(response: HttpResponseBase): Observable<ActivationAllowedResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActivationAllowedResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActivationAllowedResponse>(<any>null);
  }

  /**
   * @param userName (optional)
   * @param softwareActivationKey (optional)
   * @param manuallyActivated (optional)
   * @param reactivation (optional)
   * @return Success
   */
  saveActivation(
    userName: string | null | undefined,
    softwareActivationKey: string | null | undefined,
    manuallyActivated: boolean | undefined,
    reactivation: boolean | undefined
  ): Observable<ActivationAllowedResponse> {
    let url_ = this.baseUrl + '/api/Licensing/saveActivation?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (softwareActivationKey !== undefined && softwareActivationKey !== null) url_ += 'softwareActivationKey=' + encodeURIComponent('' + softwareActivationKey) + '&';
    if (manuallyActivated === null) throw new Error("The parameter 'manuallyActivated' cannot be null.");
    else if (manuallyActivated !== undefined) url_ += 'manuallyActivated=' + encodeURIComponent('' + manuallyActivated) + '&';
    if (reactivation === null) throw new Error("The parameter 'reactivation' cannot be null.");
    else if (reactivation !== undefined) url_ += 'reactivation=' + encodeURIComponent('' + reactivation) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveActivation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveActivation(<any>response_);
            } catch (e) {
              return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSaveActivation(response: HttpResponseBase): Observable<ActivationAllowedResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActivationAllowedResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActivationAllowedResponse>(<any>null);
  }

  /**
   * @param activationKey (optional)
   * @param userName (optional)
   * @param body (optional)
   * @return Success
   */
  saveUserData(
    activationKey: string | null | undefined,
    userName: string | null | undefined,
    body: UserDatumModel[] | null | undefined
  ): Observable<ActivationAllowedResponse> {
    let url_ = this.baseUrl + '/api/Licensing/saveUserData?';
    if (activationKey !== undefined && activationKey !== null) url_ += 'activationKey=' + encodeURIComponent('' + activationKey) + '&';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveUserData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveUserData(<any>response_);
            } catch (e) {
              return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<ActivationAllowedResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSaveUserData(response: HttpResponseBase): Observable<ActivationAllowedResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ActivationAllowedResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ActivationAllowedResponse>(<any>null);
  }
}

export interface ILogServiceProxy {
  /**
   * @param clientServerId (optional)
   * @param files (optional)
   * @return Success
   */
  uploadLogs(clientServerId: number | undefined, files: FileParameter[] | null | undefined): Observable<string>;
  /**
   * @param body (optional)
   * @return Success
   */
  writeLog(body: LogModel | undefined): Observable<void>;
}

@Injectable()
export class LogServiceProxy implements ILogServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param clientServerId (optional)
   * @param files (optional)
   * @return Success
   */
  uploadLogs(clientServerId: number | undefined, files: FileParameter[] | null | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/Log/uploadLogs?';
    if (clientServerId === null) throw new Error("The parameter 'clientServerId' cannot be null.");
    else if (clientServerId !== undefined) url_ += 'clientServerId=' + encodeURIComponent('' + clientServerId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (files !== null && files !== undefined) files.forEach((item_) => content_.append('files', item_.data, item_.fileName ? item_.fileName : 'files'));

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadLogs(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadLogs(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  writeLog(body: LogModel | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Log/writeLog';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processWriteLog(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processWriteLog(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processWriteLog(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface IMetricServiceProxy {
  /**
   * @param username (optional)
   * @param fileName (optional)
   * @param version (optional)
   * @param fullBudgetsCount (optional)
   * @param quickBudgetsCount (optional)
   * @param workSheetsCount (optional)
   * @param assetRegisterCount (optional)
   * @param gicCount (optional)
   * @param usesEnhancedInvoicing (optional)
   * @return Success
   */
  agrimasterMetrics(
    username: string | null | undefined,
    fileName: string | null | undefined,
    version: string | null | undefined,
    fullBudgetsCount: number | undefined,
    quickBudgetsCount: number | undefined,
    workSheetsCount: number | undefined,
    assetRegisterCount: number | undefined,
    gicCount: number | undefined,
    usesEnhancedInvoicing: boolean | undefined
  ): Observable<void>;
  /**
   * @param body (optional)
   * @return Success
   */
  uploadComputerStats(body: SystemInformation | undefined): Observable<void>;
}

@Injectable()
export class MetricServiceProxy implements IMetricServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param username (optional)
   * @param fileName (optional)
   * @param version (optional)
   * @param fullBudgetsCount (optional)
   * @param quickBudgetsCount (optional)
   * @param workSheetsCount (optional)
   * @param assetRegisterCount (optional)
   * @param gicCount (optional)
   * @param usesEnhancedInvoicing (optional)
   * @return Success
   */
  agrimasterMetrics(
    username: string | null | undefined,
    fileName: string | null | undefined,
    version: string | null | undefined,
    fullBudgetsCount: number | undefined,
    quickBudgetsCount: number | undefined,
    workSheetsCount: number | undefined,
    assetRegisterCount: number | undefined,
    gicCount: number | undefined,
    usesEnhancedInvoicing: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/Metric/agrimasterMetrics?';
    if (username !== undefined && username !== null) url_ += 'username=' + encodeURIComponent('' + username) + '&';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    if (version !== undefined && version !== null) url_ += 'version=' + encodeURIComponent('' + version) + '&';
    if (fullBudgetsCount === null) throw new Error("The parameter 'fullBudgetsCount' cannot be null.");
    else if (fullBudgetsCount !== undefined) url_ += 'fullBudgetsCount=' + encodeURIComponent('' + fullBudgetsCount) + '&';
    if (quickBudgetsCount === null) throw new Error("The parameter 'quickBudgetsCount' cannot be null.");
    else if (quickBudgetsCount !== undefined) url_ += 'quickBudgetsCount=' + encodeURIComponent('' + quickBudgetsCount) + '&';
    if (workSheetsCount === null) throw new Error("The parameter 'workSheetsCount' cannot be null.");
    else if (workSheetsCount !== undefined) url_ += 'workSheetsCount=' + encodeURIComponent('' + workSheetsCount) + '&';
    if (assetRegisterCount === null) throw new Error("The parameter 'assetRegisterCount' cannot be null.");
    else if (assetRegisterCount !== undefined) url_ += 'assetRegisterCount=' + encodeURIComponent('' + assetRegisterCount) + '&';
    if (gicCount === null) throw new Error("The parameter 'gicCount' cannot be null.");
    else if (gicCount !== undefined) url_ += 'gicCount=' + encodeURIComponent('' + gicCount) + '&';
    if (usesEnhancedInvoicing === null) throw new Error("The parameter 'usesEnhancedInvoicing' cannot be null.");
    else if (usesEnhancedInvoicing !== undefined) url_ += 'usesEnhancedInvoicing=' + encodeURIComponent('' + usesEnhancedInvoicing) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAgrimasterMetrics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAgrimasterMetrics(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAgrimasterMetrics(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  uploadComputerStats(body: SystemInformation | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Metric/uploadComputerStats';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadComputerStats(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadComputerStats(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadComputerStats(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface INoteServiceProxy {
  /**
   * @param fileName (optional)
   * @param revisionDate (optional)
   * @param note (optional)
   * @return Success
   */
  update(fileName: string | null | undefined, revisionDate: moment.Moment | undefined, note: string | null | undefined): Observable<void>;
  /**
   * @param revisionId (optional)
   * @param note (optional)
   * @return Success
   */
  updateNoteByRevisionId(revisionId: number | undefined, note: string | null | undefined): Observable<void>;
  /**
   * @param fileName (optional)
   * @param revisionDate (optional)
   * @param note (optional)
   * @return Success
   */
  add(fileName: string | null | undefined, revisionDate: moment.Moment | undefined, note: string | null | undefined): Observable<void>;
  /**
   * @param revisionId (optional)
   * @param note (optional)
   * @return Success
   */
  addNoteByRevisionId(revisionId: number | undefined, note: string | null | undefined): Observable<void>;
}

@Injectable()
export class NoteServiceProxy implements INoteServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param fileName (optional)
   * @param revisionDate (optional)
   * @param note (optional)
   * @return Success
   */
  update(fileName: string | null | undefined, revisionDate: moment.Moment | undefined, note: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Note/update?';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    if (revisionDate === null) throw new Error("The parameter 'revisionDate' cannot be null.");
    else if (revisionDate !== undefined) url_ += 'revisionDate=' + encodeURIComponent(revisionDate ? '' + revisionDate.toJSON() : '') + '&';
    if (note !== undefined && note !== null) url_ += 'note=' + encodeURIComponent('' + note) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param revisionId (optional)
   * @param note (optional)
   * @return Success
   */
  updateNoteByRevisionId(revisionId: number | undefined, note: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Note/updateNoteByRevisionId?';
    if (revisionId === null) throw new Error("The parameter 'revisionId' cannot be null.");
    else if (revisionId !== undefined) url_ += 'revisionId=' + encodeURIComponent('' + revisionId) + '&';
    if (note !== undefined && note !== null) url_ += 'note=' + encodeURIComponent('' + note) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateNoteByRevisionId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateNoteByRevisionId(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateNoteByRevisionId(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param fileName (optional)
   * @param revisionDate (optional)
   * @param note (optional)
   * @return Success
   */
  add(fileName: string | null | undefined, revisionDate: moment.Moment | undefined, note: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Note/add?';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    if (revisionDate === null) throw new Error("The parameter 'revisionDate' cannot be null.");
    else if (revisionDate !== undefined) url_ += 'revisionDate=' + encodeURIComponent(revisionDate ? '' + revisionDate.toJSON() : '') + '&';
    if (note !== undefined && note !== null) url_ += 'note=' + encodeURIComponent('' + note) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdd(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdd(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAdd(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param revisionId (optional)
   * @param note (optional)
   * @return Success
   */
  addNoteByRevisionId(revisionId: number | undefined, note: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Note/addNoteByRevisionId?';
    if (revisionId === null) throw new Error("The parameter 'revisionId' cannot be null.");
    else if (revisionId !== undefined) url_ += 'revisionId=' + encodeURIComponent('' + revisionId) + '&';
    if (note !== undefined && note !== null) url_ += 'note=' + encodeURIComponent('' + note) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddNoteByRevisionId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddNoteByRevisionId(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddNoteByRevisionId(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface INotificationServiceProxy {
  /**
   * @param userNumber (optional)
   * @return Success
   */
  list2(userNumber: string | null | undefined): Observable<NotificationModel[]>;
  /**
   * @param notificationId (optional)
   * @param userNumber (optional)
   * @return Success
   */
  read(notificationId: number | undefined, userNumber: string | null | undefined): Observable<void>;
}

@Injectable()
export class NotificationServiceProxy implements INotificationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param userNumber (optional)
   * @return Success
   */
  list2(userNumber: string | null | undefined): Observable<NotificationModel[]> {
    let url_ = this.baseUrl + '/api/Notification/list?';
    if (userNumber !== undefined && userNumber !== null) url_ += 'userNumber=' + encodeURIComponent('' + userNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processList2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processList2(<any>response_);
            } catch (e) {
              return <Observable<NotificationModel[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<NotificationModel[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processList2(response: HttpResponseBase): Observable<NotificationModel[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(NotificationModel.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as NotificationModel[]);
  }

  /**
   * @param notificationId (optional)
   * @param userNumber (optional)
   * @return Success
   */
  read(notificationId: number | undefined, userNumber: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Notification/read?';
    if (notificationId === null) throw new Error("The parameter 'notificationId' cannot be null.");
    else if (notificationId !== undefined) url_ += 'notificationId=' + encodeURIComponent('' + notificationId) + '&';
    if (userNumber !== undefined && userNumber !== null) url_ += 'userNumber=' + encodeURIComponent('' + userNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRead(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface IPayrollServiceProxy {
  /**
   * @param body (optional)
   * @return Success
   */
  addIntegration(body: PayrollAccountModel | undefined): Observable<void>;
  /**
   * @param businessId (optional)
   * @return Success
   */
  deleteIntegration(businessId: number | undefined): Observable<void>;
  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayrollAllowances(businessId: number | undefined): Observable<PayrollAllowance[]>;
  /**
   * @param businessId (optional)
   * @return Success
   */
  getConfigOptions(businessId: number | undefined): Observable<PayrollConfigModel>;
  /**
   * @param businessId (optional)
   * @param body (optional)
   * @return Success
   */
  savePayrollSetup(businessId: number | undefined, body: PayrollSetupModel | undefined): Observable<void>;
  /**
   * @param businessId (optional)
   * @param externalPayRunId (optional)
   * @param paymentDate (optional)
   * @param superDate (optional)
   * @param invoiceDate (optional)
   * @return Success
   */
  getImportPreview(
    businessId: number | undefined,
    externalPayRunId: number | undefined,
    paymentDate: moment.Moment | undefined,
    superDate: moment.Moment | undefined,
    invoiceDate: moment.Moment | null | undefined
  ): Observable<Transaction[]>;
  /**
   * @param businessId (optional)
   * @param externalPayRunId (optional)
   * @param requestingUser (optional)
   * @param paymentDate (optional)
   * @param superDate (optional)
   * @param invoiceDate (optional)
   * @return Success
   */
  importPayroll(
    businessId: number | undefined,
    externalPayRunId: number | undefined,
    requestingUser: string | null | undefined,
    paymentDate: moment.Moment | undefined,
    superDate: moment.Moment | undefined,
    invoiceDate: moment.Moment | null | undefined
  ): Observable<void>;
  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayRuns(businessId: number | undefined): Observable<PayrollPayRun[]>;
  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayrollEmployees(businessId: number | undefined): Observable<PayrollEmployee[]>;
}

@Injectable()
export class PayrollServiceProxy implements IPayrollServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addIntegration(body: PayrollAccountModel | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Payroll/addIntegration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddIntegration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddIntegration(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAddIntegration(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  deleteIntegration(businessId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Payroll/deleteIntegration?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteIntegration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteIntegration(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteIntegration(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayrollAllowances(businessId: number | undefined): Observable<PayrollAllowance[]> {
    let url_ = this.baseUrl + '/api/Payroll/getPayrollAllowances?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPayrollAllowances(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPayrollAllowances(<any>response_);
            } catch (e) {
              return <Observable<PayrollAllowance[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PayrollAllowance[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPayrollAllowances(response: HttpResponseBase): Observable<PayrollAllowance[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PayrollAllowance.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as PayrollAllowance[]);
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  getConfigOptions(businessId: number | undefined): Observable<PayrollConfigModel> {
    let url_ = this.baseUrl + '/api/Payroll/getConfigOptions?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfigOptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetConfigOptions(<any>response_);
            } catch (e) {
              return <Observable<PayrollConfigModel>>(<any>_observableThrow(e));
            }
          } else return <Observable<PayrollConfigModel>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetConfigOptions(response: HttpResponseBase): Observable<PayrollConfigModel> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PayrollConfigModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PayrollConfigModel>(<any>null);
  }

  /**
   * @param businessId (optional)
   * @param body (optional)
   * @return Success
   */
  savePayrollSetup(businessId: number | undefined, body: PayrollSetupModel | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Payroll/savePayrollSetup?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSavePayrollSetup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSavePayrollSetup(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSavePayrollSetup(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param businessId (optional)
   * @param externalPayRunId (optional)
   * @param paymentDate (optional)
   * @param superDate (optional)
   * @param invoiceDate (optional)
   * @return Success
   */
  getImportPreview(
    businessId: number | undefined,
    externalPayRunId: number | undefined,
    paymentDate: moment.Moment | undefined,
    superDate: moment.Moment | undefined,
    invoiceDate: moment.Moment | null | undefined
  ): Observable<Transaction[]> {
    let url_ = this.baseUrl + '/api/Payroll/getImportPreview?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    if (externalPayRunId === null) throw new Error("The parameter 'externalPayRunId' cannot be null.");
    else if (externalPayRunId !== undefined) url_ += 'externalPayRunId=' + encodeURIComponent('' + externalPayRunId) + '&';
    if (paymentDate === null) throw new Error("The parameter 'paymentDate' cannot be null.");
    else if (paymentDate !== undefined) url_ += 'paymentDate=' + encodeURIComponent(paymentDate ? '' + paymentDate.toJSON() : '') + '&';
    if (superDate === null) throw new Error("The parameter 'superDate' cannot be null.");
    else if (superDate !== undefined) url_ += 'superDate=' + encodeURIComponent(superDate ? '' + superDate.toJSON() : '') + '&';
    if (invoiceDate !== undefined && invoiceDate !== null) url_ += 'invoiceDate=' + encodeURIComponent(invoiceDate ? '' + invoiceDate.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetImportPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetImportPreview(<any>response_);
            } catch (e) {
              return <Observable<Transaction[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Transaction[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetImportPreview(response: HttpResponseBase): Observable<Transaction[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Transaction.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as Transaction[]);
  }

  /**
   * @param businessId (optional)
   * @param externalPayRunId (optional)
   * @param requestingUser (optional)
   * @param paymentDate (optional)
   * @param superDate (optional)
   * @param invoiceDate (optional)
   * @return Success
   */
  importPayroll(
    businessId: number | undefined,
    externalPayRunId: number | undefined,
    requestingUser: string | null | undefined,
    paymentDate: moment.Moment | undefined,
    superDate: moment.Moment | undefined,
    invoiceDate: moment.Moment | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/Payroll/importPayroll?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    if (externalPayRunId === null) throw new Error("The parameter 'externalPayRunId' cannot be null.");
    else if (externalPayRunId !== undefined) url_ += 'externalPayRunId=' + encodeURIComponent('' + externalPayRunId) + '&';
    if (requestingUser !== undefined && requestingUser !== null) url_ += 'requestingUser=' + encodeURIComponent('' + requestingUser) + '&';
    if (paymentDate === null) throw new Error("The parameter 'paymentDate' cannot be null.");
    else if (paymentDate !== undefined) url_ += 'paymentDate=' + encodeURIComponent(paymentDate ? '' + paymentDate.toJSON() : '') + '&';
    if (superDate === null) throw new Error("The parameter 'superDate' cannot be null.");
    else if (superDate !== undefined) url_ += 'superDate=' + encodeURIComponent(superDate ? '' + superDate.toJSON() : '') + '&';
    if (invoiceDate !== undefined && invoiceDate !== null) url_ += 'invoiceDate=' + encodeURIComponent(invoiceDate ? '' + invoiceDate.toJSON() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImportPayroll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImportPayroll(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processImportPayroll(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayRuns(businessId: number | undefined): Observable<PayrollPayRun[]> {
    let url_ = this.baseUrl + '/api/Payroll/getPayRuns?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPayRuns(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPayRuns(<any>response_);
            } catch (e) {
              return <Observable<PayrollPayRun[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PayrollPayRun[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPayRuns(response: HttpResponseBase): Observable<PayrollPayRun[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PayrollPayRun.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as PayrollPayRun[]);
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  getPayrollEmployees(businessId: number | undefined): Observable<PayrollEmployee[]> {
    let url_ = this.baseUrl + '/api/Payroll/getPayrollEmployees?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPayrollEmployees(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPayrollEmployees(<any>response_);
            } catch (e) {
              return <Observable<PayrollEmployee[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<PayrollEmployee[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetPayrollEmployees(response: HttpResponseBase): Observable<PayrollEmployee[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PayrollEmployee.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as PayrollEmployee[]);
  }
}

export interface IProfileServiceProxy {
  /**
   * @param userId (optional)
   * @return Success
   */
  profile(userId: string | null | undefined): Observable<UserProfile>;
  /**
   * @param userName (optional)
   * @param emailAddress (optional)
   * @return Success
   */
  verification(userName: string | null | undefined, emailAddress: string | null | undefined): Observable<UserProfile>;
  /**
   * @return Success
   */
  getUnlinkedSubscriptions(): Observable<SubscriptionInfo[]>;
  /**
   * @param userId (optional)
   * @param emailAddress (optional)
   * @return Success
   */
  resetPassword(userId: string | null | undefined, emailAddress: string | null | undefined): Observable<void>;
  /**
   * @param userName (optional)
   * @return Success
   */
  adminReset(userName: string | null | undefined): Observable<PasswordResetResponse>;
  /**
   * @param oldPassword (optional)
   * @param newPassword (optional)
   * @return Success
   */
  changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @return Success
   */
  changePassword2(body: PasswordChangeRequest | undefined): Observable<void>;
  /**
   * @return Success
   */
  fileManagerToken(username: string, password: string): Observable<string>;
  /**
   * @param body (optional)
   * @return Success
   */
  validateNewUserEmailAddress(body: EmailRequest | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @return Success
   */
  generateNewUserRegistrationCode(body: EmailRequest | undefined): Observable<NewUserGuidResponse>;
  /**
   * @param body (optional)
   * @return Success
   */
  validateNewUserRegistrationCode(body: RegistrationCodeRequest | undefined): Observable<void>;
  /**
   * @param body (optional)
   * @return Success
   */
  createNewUserAccount(body: UserAccountRequest | undefined): Observable<UserProfile>;
  /**
   * @param body (optional)
   * @return Success
   */
  createNewUserAccountFromStaff(body: UserAccountRequest | undefined): Observable<UserProfile>;
}

@Injectable()
export class ProfileServiceProxy implements IProfileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  profile(userId: string | null | undefined): Observable<UserProfile> {
    let url_ = this.baseUrl + '/api/Profile?';
    if (userId !== undefined && userId !== null) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfile(<any>response_);
            } catch (e) {
              return <Observable<UserProfile>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserProfile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processProfile(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(<any>null);
  }

  /**
   * @param userName (optional)
   * @param emailAddress (optional)
   * @return Success
   */
  verification(userName: string | null | undefined, emailAddress: string | null | undefined): Observable<UserProfile> {
    let url_ = this.baseUrl + '/api/Profile/verification?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (emailAddress !== undefined && emailAddress !== null) url_ += 'emailAddress=' + encodeURIComponent('' + emailAddress) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerification(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerification(<any>response_);
            } catch (e) {
              return <Observable<UserProfile>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserProfile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processVerification(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(<any>null);
  }

  /**
   * @return Success
   */
  getUnlinkedSubscriptions(): Observable<SubscriptionInfo[]> {
    let url_ = this.baseUrl + '/api/Profile/getUnlinkedSubscriptions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUnlinkedSubscriptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUnlinkedSubscriptions(<any>response_);
            } catch (e) {
              return <Observable<SubscriptionInfo[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<SubscriptionInfo[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetUnlinkedSubscriptions(response: HttpResponseBase): Observable<SubscriptionInfo[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(SubscriptionInfo.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as SubscriptionInfo[]);
  }

  /**
   * @param userId (optional)
   * @param emailAddress (optional)
   * @return Success
   */
  resetPassword(userId: string | null | undefined, emailAddress: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Profile/resetPassword?';
    if (userId !== undefined && userId !== null) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (emailAddress !== undefined && emailAddress !== null) url_ += 'emailAddress=' + encodeURIComponent('' + emailAddress) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param userName (optional)
   * @return Success
   */
  adminReset(userName: string | null | undefined): Observable<PasswordResetResponse> {
    let url_ = this.baseUrl + '/api/Profile/adminReset?';
    if (userName !== undefined && userName !== null) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdminReset(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdminReset(<any>response_);
            } catch (e) {
              return <Observable<PasswordResetResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<PasswordResetResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processAdminReset(response: HttpResponseBase): Observable<PasswordResetResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PasswordResetResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PasswordResetResponse>(<any>null);
  }

  /**
   * @param oldPassword (optional)
   * @param newPassword (optional)
   * @return Success
   */
  changePassword(oldPassword: string | null | undefined, newPassword: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Profile/changePassword?';
    if (oldPassword !== undefined && oldPassword !== null) url_ += 'oldPassword=' + encodeURIComponent('' + oldPassword) + '&';
    if (newPassword !== undefined && newPassword !== null) url_ += 'newPassword=' + encodeURIComponent('' + newPassword) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword2(body: PasswordChangeRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Profile/v2/changePassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword2(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword2(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePassword2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  fileManagerToken(username: string, password: string): Observable<string> {
    let url_ = this.baseUrl + '/api/Profile/fileManagerToken';
    url_ = url_.replace(/[?&]$/, '');

    let options_: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'text';
      withCredentials?: boolean;
    } = {
      headers: new HttpHeaders({
        Authorization: 'Basic ' + window.btoa(username + ':' + password)
      }),
      responseType: 'text'
    };

    return this.http.get(url_, options_);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  validateNewUserEmailAddress(body: EmailRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Profile/validateNewUserEmailAddress';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidateNewUserEmailAddress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidateNewUserEmailAddress(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidateNewUserEmailAddress(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
  /**
   * @param body (optional)
   * @return Success
   */
  generateNewUserRegistrationCode(body: EmailRequest | undefined): Observable<NewUserGuidResponse> {
    let url_ = this.baseUrl + '/api/Profile/generateNewUserRegistrationCode';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGenerateNewUserRegistrationCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGenerateNewUserRegistrationCode(<any>response_);
            } catch (e) {
              return <Observable<NewUserGuidResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<NewUserGuidResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGenerateNewUserRegistrationCode(response: HttpResponseBase): Observable<NewUserGuidResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NewUserGuidResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<NewUserGuidResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  validateNewUserRegistrationCode(body: RegistrationCodeRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Profile/ValidateNewUserRegistrationCode';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidateNewUserRegistrationCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidateNewUserRegistrationCode(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processValidateNewUserRegistrationCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createNewUserAccount(body: UserAccountRequest | undefined): Observable<UserProfile> {
    let url_ = this.baseUrl + '/api/Profile/createNewUserAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateNewUserAccount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateNewUserAccount(<any>response_);
            } catch (e) {
              return <Observable<UserProfile>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserProfile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateNewUserAccount(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createNewUserAccountFromStaff(body: UserAccountRequest | undefined): Observable<UserProfile> {
    let url_ = this.baseUrl + '/api/Profile/createNewUserAccountFromStaff';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateNewUserAccountFromStaff(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateNewUserAccountFromStaff(<any>response_);
            } catch (e) {
              return <Observable<UserProfile>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserProfile>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateNewUserAccountFromStaff(response: HttpResponseBase): Observable<UserProfile> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfile.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserProfile>(<any>null);
  }
}

export interface IPurchasingServiceProxy {
  /**
   * @return Success
   */
  productAll(): Observable<ShopProduct[]>;
  /**
   * @return Success
   */
  product(productId: string | null): Observable<ShopProduct>;
  /**
   * @param body (optional)
   * @return Success
   */
  purchase(body: SubscriptionRequest | undefined): Observable<SubscriptionResponse>;
  /**
   * @param body (optional)
   * @return Success
   */
  purchaseOwn(body: SubscriptionRequest | undefined): Observable<SubscriptionResponse>;
  /**
   * @param body (optional)
   * @return Success
   */
  purchaseAgs7(body: Ags7SubscriptionRequest | undefined): Observable<SubscriptionResponse>;
  /**
   * @param userName (optional)
   * @param productId (optional)
   * @param coupon (optional)
   * @param primarySubscriptionId (optional)
   * @return Success
   */
  proration(userName: string | undefined, productId: string | undefined, coupon: string | undefined, primarySubscriptionId: number | undefined): Observable<ProRataDetails>;
  /**
   * @param subscriptionId (optional)
   * @return Success
   */
  billing(subscriptionId: number | undefined): Observable<BillingPortalSession>;
  /**
   * @param userName (optional)
   * @return Success
   */
  candidatePrimarySubscriptions(userName?: string | undefined): Observable<SubscriptionInfo[]>;

  /**
   * @param userName (optional)
   * @return Success
   */
  subscriptions(userName: string | undefined): Observable<SubscriptionInfo[]>;
}

@Injectable()
export class PurchasingServiceProxy implements IPurchasingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @return Success
   */
  productAll(): Observable<ShopProduct[]> {
    let url_ = this.baseUrl + '/api/Purchasing/product';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProductAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProductAll(<any>response_);
            } catch (e) {
              return <Observable<ShopProduct[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<ShopProduct[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processProductAll(response: HttpResponseBase): Observable<ShopProduct[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ShopProduct.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as ShopProduct[]);
  }

  /**
   * @return Success
   */
  product(productId: string | null): Observable<ShopProduct> {
    let url_ = this.baseUrl + '/api/Purchasing/product/{productId}';
    if (productId === undefined || productId === null) throw new Error("The parameter 'productId' must be defined.");
    url_ = url_.replace('{productId}', encodeURIComponent('' + productId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProduct(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProduct(<any>response_);
            } catch (e) {
              return <Observable<ShopProduct>>(<any>_observableThrow(e));
            }
          } else return <Observable<ShopProduct>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processProduct(response: HttpResponseBase): Observable<ShopProduct> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ShopProduct.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ShopProduct>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  purchase(body: SubscriptionRequest | undefined): Observable<SubscriptionResponse> {
    let url_ = this.baseUrl + '/api/Purchasing/purchase';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPurchase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPurchase(<any>response_);
            } catch (e) {
              return <Observable<SubscriptionResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<SubscriptionResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPurchase(response: HttpResponseBase): Observable<SubscriptionResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SubscriptionResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SubscriptionResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  purchaseOwn(body: SubscriptionRequest | undefined): Observable<SubscriptionResponse> {
    let url_ = this.baseUrl + '/api/Purchasing/purchaseOwn';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPurchaseOwn(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPurchaseOwn(<any>response_);
            } catch (e) {
              return <Observable<SubscriptionResponse>>(<any>_observableThrow(e));
            }
          } else return <Observable<SubscriptionResponse>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPurchaseOwn(response: HttpResponseBase): Observable<SubscriptionResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SubscriptionResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<SubscriptionResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  purchaseAgs7(body: Ags7SubscriptionRequest | undefined): Observable<SubscriptionResponse> {
    let url_ = this.baseUrl + '/api/Purchasing/purchaseAgs7';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPurchaseAgs7(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPurchaseAgs7(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SubscriptionResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<SubscriptionResponse>;
        })
      );
  }

  protected processPurchaseAgs7(response: HttpResponseBase): Observable<SubscriptionResponse> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SubscriptionResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userName (optional)
   * @param productId (optional)
   * @param coupon (optional)
   * @param primarySubscriptionId (optional)
   * @return Success
   */
  proration(userName: string | undefined, productId: string | undefined, coupon: string | undefined, primarySubscriptionId: number | undefined): Observable<ProRataDetails> {
    let url_ = this.baseUrl + '/api/Purchasing/proration?';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
    else if (productId !== undefined) url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
    if (coupon === null) throw new Error("The parameter 'coupon' cannot be null.");
    else if (coupon !== undefined) url_ += 'coupon=' + encodeURIComponent('' + coupon) + '&';
    else if (primarySubscriptionId !== undefined && primarySubscriptionId > 0) url_ += 'primarySubscriptionId=' + encodeURIComponent('' + primarySubscriptionId) + '&';

    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProration(<any>response_);
            } catch (e) {
              return <Observable<ProRataDetails>>(<any>_observableThrow(e));
            }
          } else return <Observable<ProRataDetails>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processProration(response: HttpResponseBase): Observable<ProRataDetails> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProRataDetails.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<ProRataDetails>(<any>null);
  }

  /**
   * @param subscriptionId (optional)
   * @return Success
   */
  billing(subscriptionId: number | undefined): Observable<BillingPortalSession> {
    let url_ = this.baseUrl + '/api/Purchasing/billing?';
    if (subscriptionId === null) throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined) url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBilling(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBilling(<any>response_);
            } catch (e) {
              return <Observable<BillingPortalSession>>(<any>_observableThrow(e));
            }
          } else return <Observable<BillingPortalSession>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processBilling(response: HttpResponseBase): Observable<BillingPortalSession> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BillingPortalSession.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<BillingPortalSession>(<any>null);
  }

  /**
   * @param userName (optional)
   * @return Success
   */
  candidatePrimarySubscriptions(userName?: string | undefined): Observable<SubscriptionInfo[]> {
    let url_ = this.baseUrl + '/api/Purchasing/candidatePrimarySubscriptions?';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCandidatePrimarySubscriptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCandidatePrimarySubscriptions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SubscriptionInfo[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SubscriptionInfo[]>;
        })
      );
  }

  protected processCandidatePrimarySubscriptions(response: HttpResponseBase): Observable<SubscriptionInfo[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(SubscriptionInfo.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userName (optional)
   * @return Success
   */
  subscriptions(userName: string | undefined): Observable<SubscriptionInfo[]> {
    let url_ = this.baseUrl + '/api/Purchasing/subscriptions?';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubscriptions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubscriptions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SubscriptionInfo[]>;
            }
          } else return _observableThrow(response_) as any as Observable<SubscriptionInfo[]>;
        })
      );
  }

  protected processSubscriptions(response: HttpResponseBase): Observable<SubscriptionInfo[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(SubscriptionInfo.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IRandomServiceProxy {
  /**
   * @param length (optional)
   * @return Success
   */
  password(length: number | undefined): Observable<PasswordResponseModel>;
}

@Injectable()
export class RandomServiceProxy implements IRandomServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param length (optional)
   * @return Success
   */
  password(length: number | undefined): Observable<PasswordResponseModel> {
    let url_ = this.baseUrl + '/api/Random/password?';
    if (length === null) throw new Error("The parameter 'length' cannot be null.");
    else if (length !== undefined) url_ += 'length=' + encodeURIComponent('' + length) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPassword(<any>response_);
            } catch (e) {
              return <Observable<PasswordResponseModel>>(<any>_observableThrow(e));
            }
          } else return <Observable<PasswordResponseModel>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processPassword(response: HttpResponseBase): Observable<PasswordResponseModel> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PasswordResponseModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<PasswordResponseModel>(<any>null);
  }
}

export interface IStatusServiceProxy {
  /**
   * @return Success
   */
  status(): Observable<void>;
}

@Injectable()
export class StatusServiceProxy implements IStatusServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @return Success
   */
  status(): Observable<void> {
    let url_ = this.baseUrl + '/api/Status';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export interface ITransactionServiceProxy {
  /**
   * @param businessId (optional)
   * @return Success
   */
  listTransactions(businessId: number | undefined): Observable<Transaction[]>;
}

@Injectable()
export class TransactionServiceProxy implements ITransactionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @param businessId (optional)
   * @return Success
   */
  listTransactions(businessId: number | undefined): Observable<Transaction[]> {
    let url_ = this.baseUrl + '/api/Transaction/listTransactions?';
    if (businessId === null) throw new Error("The parameter 'businessId' cannot be null.");
    else if (businessId !== undefined) url_ += 'businessId=' + encodeURIComponent('' + businessId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListTransactions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListTransactions(<any>response_);
            } catch (e) {
              return <Observable<Transaction[]>>(<any>_observableThrow(e));
            }
          } else return <Observable<Transaction[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processListTransactions(response: HttpResponseBase): Observable<Transaction[]> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Transaction.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as Transaction[]);
  }
}

export interface IUpdatesServiceProxy {
  /**
   * @return Success
   */
  latest(): Observable<void>;
  /**
   * @param groupType (optional)
   * @param body (optional)
   * @return Success
   */
  requestUpdate(groupType: string | null | undefined, body: SystemUpdaterFileInformation[] | null | undefined): Observable<void>;
}

@Injectable()
export class UpdatesServiceProxy implements IUpdatesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, config: AppConfigService) {
    this.http = http;
    this.baseUrl = config.getApiUrl();
  }

  /**
   * @return Success
   */
  latest(): Observable<void> {
    let url_ = this.baseUrl + '/api/Updates/latest';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({})
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLatest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLatest(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processLatest(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param groupType (optional)
   * @param body (optional)
   * @return Success
   */
  requestUpdate(groupType: string | null | undefined, body: SystemUpdaterFileInformation[] | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Updates/requestUpdate?';
    if (groupType !== undefined && groupType !== null) url_ += 'groupType=' + encodeURIComponent('' + groupType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRequestUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRequestUpdate(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRequestUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

export class HardwareInformation implements IHardwareInformation {
  hardwareKey?: string | undefined;
  serverName?: string | undefined;

  constructor(data?: IHardwareInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hardwareKey = _data['hardwareKey'];
      this.serverName = _data['serverName'];
    }
  }

  static fromJS(data: any): HardwareInformation {
    data = typeof data === 'object' ? data : {};
    let result = new HardwareInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['hardwareKey'] = this.hardwareKey;
    data['serverName'] = this.serverName;
    return data;
  }
}

export interface IHardwareInformation {
  hardwareKey?: string | undefined;
  serverName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export enum ChangeState {
  Current = 'current',
  New = 'new',
  Updated = 'updated',
  Deleted = 'deleted'
}

export class BankAccount implements IBankAccount {
  id?: number;
  typeId?: number;
  typeName?: string | undefined;
  name?: string | undefined;
  bank?: string | undefined;
  bsb?: string | undefined;
  accountNumber?: string | undefined;
  openDate?: moment.Moment;
  closeDate?: moment.Moment | undefined;
  isActive?: boolean;
  apcaNumber?: string | undefined;
  isWheatLoan?: boolean;
  eftExportBankId?: number | undefined;
  eftExportBank?: string | undefined;
  state?: ChangeState;

  constructor(data?: IBankAccount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.typeId = _data['typeId'];
      this.typeName = _data['typeName'];
      this.name = _data['name'];
      this.bank = _data['bank'];
      this.bsb = _data['bsb'];
      this.accountNumber = _data['accountNumber'];
      this.openDate = _data['openDate'] ? moment(_data['openDate'].toString()) : <any>undefined;
      this.closeDate = _data['closeDate'] ? moment(_data['closeDate'].toString()) : <any>undefined;
      this.isActive = _data['isActive'];
      this.apcaNumber = _data['apcaNumber'];
      this.isWheatLoan = _data['isWheatLoan'];
      this.eftExportBankId = _data['eftExportBankId'];
      this.eftExportBank = _data['eftExportBank'];
      this.state = _data['state'];
    }
  }

  static fromJS(data: any): BankAccount {
    data = typeof data === 'object' ? data : {};
    let result = new BankAccount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['typeId'] = this.typeId;
    data['typeName'] = this.typeName;
    data['name'] = this.name;
    data['bank'] = this.bank;
    data['bsb'] = this.bsb;
    data['accountNumber'] = this.accountNumber;
    data['openDate'] = this.openDate ? this.openDate.toISOString() : <any>undefined;
    data['closeDate'] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
    data['isActive'] = this.isActive;
    data['apcaNumber'] = this.apcaNumber;
    data['isWheatLoan'] = this.isWheatLoan;
    data['eftExportBankId'] = this.eftExportBankId;
    data['eftExportBank'] = this.eftExportBank;
    data['state'] = this.state;
    return data;
  }
}

export interface IBankAccount {
  id?: number;
  typeId?: number;
  typeName?: string | undefined;
  name?: string | undefined;
  bank?: string | undefined;
  bsb?: string | undefined;
  accountNumber?: string | undefined;
  openDate?: moment.Moment;
  closeDate?: moment.Moment | undefined;
  isActive?: boolean;
  apcaNumber?: string | undefined;
  isWheatLoan?: boolean;
  eftExportBankId?: number | undefined;
  eftExportBank?: string | undefined;
  state?: ChangeState;
}

export class Int64StringKeyValuePair implements IInt64StringKeyValuePair {
  readonly key?: number;
  readonly value?: string | undefined;

  constructor(data?: IInt64StringKeyValuePair) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).key = _data['key'];
      (<any>this).value = _data['value'];
    }
  }

  static fromJS(data: any): Int64StringKeyValuePair {
    data = typeof data === 'object' ? data : {};
    let result = new Int64StringKeyValuePair();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['value'] = this.value;
    return data;
  }
}

export interface IInt64StringKeyValuePair {
  key?: number;
  value?: string | undefined;
}

export class InitialisationResponse implements IInitialisationResponse {
  url?: string | undefined;
  iframeUrl?: string | undefined;

  constructor(data?: IInitialisationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url'];
      this.iframeUrl = _data['iframeUrl'];
    }
  }

  static fromJS(data: any): InitialisationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new InitialisationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['url'] = this.url;
    data['iframeUrl'] = this.iframeUrl;
    return data;
  }
}

export interface IInitialisationResponse {
  url?: string | undefined;
  iframeUrl?: string | undefined;
}

export class DeleteResponse implements IDeleteResponse {
  success?: boolean;
  message?: string | undefined;
  customerId?: string | undefined;

  constructor(data?: IDeleteResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data['success'];
      this.message = _data['message'];
      this.customerId = _data['customerId'];
    }
  }

  static fromJS(data: any): DeleteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DeleteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['success'] = this.success;
    data['message'] = this.message;
    data['customerId'] = this.customerId;
    return data;
  }
}

export interface IDeleteResponse {
  success?: boolean;
  message?: string | undefined;
  customerId?: string | undefined;
}

export class Business implements IBusiness {
  id?: number;
  name?: string | undefined;
  creationDate?: moment.Moment;
  modifiedDate?: moment.Moment;
  ownerId?: number;
  subscriptionId?: number | undefined;

  constructor(data?: IBusiness) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.creationDate = _data['creationDate'] ? moment(_data['creationDate'].toString()) : <any>undefined;
      this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
      this.ownerId = _data['ownerId'];
      this.subscriptionId = _data['subscriptionId'];
    }
  }

  static fromJS(data: any): Business {
    data = typeof data === 'object' ? data : {};
    let result = new Business();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['creationDate'] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
    data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
    data['ownerId'] = this.ownerId;
    data['subscriptionId'] = this.subscriptionId;
    return data;
  }
}

export interface IBusiness {
  id?: number;
  name?: string | undefined;
  creationDate?: moment.Moment;
  modifiedDate?: moment.Moment;
  ownerId?: number;
  subscriptionId?: number | undefined;
}

export class BusinessNumberResponse implements IBusinessNumberResponse {
  abn?: string | undefined;
  status?: string | undefined;
  addressDate?: moment.Moment;
  isExpired?: boolean;
  addressPostcode?: string | undefined;
  addressState?: string | undefined;
  entityName?: string | undefined;
  entityType?: string | undefined;
  businessName?: string[] | undefined;

  constructor(data?: IBusinessNumberResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.abn = _data['abn'];
      this.status = _data['status'];
      this.addressDate = _data['addressDate'] ? moment(_data['addressDate'].toString()) : <any>undefined;
      this.isExpired = _data['isExpired'];
      this.addressPostcode = _data['addressPostcode'];
      this.addressState = _data['addressState'];
      this.entityName = _data['entityName'];
      this.entityType = _data['entityType'];
      if (Array.isArray(_data['businessName'])) {
        this.businessName = [] as any;
        for (let item of _data['businessName']) this.businessName!.push(item);
      }
    }
  }

  static fromJS(data: any): BusinessNumberResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BusinessNumberResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['abn'] = this.abn;
    data['status'] = this.status;
    data['addressDate'] = this.addressDate ? this.addressDate.toISOString() : <any>undefined;
    data['isExpired'] = this.isExpired;
    data['addressPostcode'] = this.addressPostcode;
    data['addressState'] = this.addressState;
    data['entityName'] = this.entityName;
    data['entityType'] = this.entityType;
    if (Array.isArray(this.businessName)) {
      data['businessName'] = [];
      for (let item of this.businessName) data['businessName'].push(item);
    }
    return data;
  }
}

export interface IBusinessNumberResponse {
  abn?: string | undefined;
  status?: string | undefined;
  addressDate?: moment.Moment;
  isExpired?: boolean;
  addressPostcode?: string | undefined;
  addressState?: string | undefined;
  entityName?: string | undefined;
  entityType?: string | undefined;
  businessName?: string[] | undefined;
}

export enum DocumentType {
  CompanyVerification = 'companyVerification',
  Receipt = 'receipt',
  Invoice = 'invoice',
  BankStatement = 'bankStatement'
}

export enum BackupType {
  All = 'All',
  Agrimaster = 'Agrimaster',
  Wagemaster = 'Wagemaster',
  Businessmaster = 'Businessmaster'
}

export class Profile implements IProfile {
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  edition?: string | undefined;

  constructor(data?: IProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.companyName = _data['companyName'];
      this.abn = _data['abn'];
      this.edition = _data['edition'];
    }
  }

  static fromJS(data: any): Profile {
    data = typeof data === 'object' ? data : {};
    let result = new Profile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['companyName'] = this.companyName;
    data['abn'] = this.abn;
    data['edition'] = this.edition;
    return data;
  }
}

export interface IProfile {
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  edition?: string | undefined;
}

export class BusinessName implements IBusinessName {
  name?: string | undefined;

  constructor(data?: IBusinessName) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): BusinessName {
    data = typeof data === 'object' ? data : {};
    let result = new BusinessName();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface IBusinessName {
  name?: string | undefined;
}

export class SubscriptionInfo implements ISubscriptionInfo {
  userId?: number;
  subscriptionId?: number;
  entityName?: string | undefined;
  abn?: string | undefined;
  planType?: string | undefined;
  expiryDate?: moment.Moment;
  businessNames?: BusinessName[] | undefined;

  constructor(data?: ISubscriptionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.subscriptionId = _data['subscriptionId'];
      this.entityName = _data['entityName'];
      this.abn = _data['abn'];
      this.planType = _data['planType'];
      this.expiryDate = _data['expiryDate'] ? moment(_data['expiryDate'].toString()) : <any>undefined;
      if (Array.isArray(_data['businessNames'])) {
        this.businessNames = [] as any;
        for (let item of _data['businessNames']) this.businessNames!.push(BusinessName.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SubscriptionInfo {
    data = typeof data === 'object' ? data : {};
    let result = new SubscriptionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['subscriptionId'] = this.subscriptionId;
    data['entityName'] = this.entityName;
    data['abn'] = this.abn;
    data['planType'] = this.planType;
    data['expiryDate'] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
    if (Array.isArray(this.businessNames)) {
      data['businessNames'] = [];
      for (let item of this.businessNames) data['businessNames'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISubscriptionInfo {
  userId?: number;
  subscriptionId?: number;
  entityName?: string | undefined;
  abn?: string | undefined;
  planType?: string | undefined;
  expiryDate?: moment.Moment;
  businessNames?: BusinessName[] | undefined;
}

export class BackupFile implements IBackupFile {
  id?: number | undefined;
  name!: string;
  userOwnedBy!: Profile;
  userSavedBy?: Profile;
  fileSize!: number;
  modifiedDate!: moment.Moment;
  fileType!: BackupType;
  fileChecksum?: string | undefined;
  modifiedFileChecksum?: string | undefined;
  note?: string | undefined;
  businessId?: number;
  subscriptionId?: number | undefined;
  subscription?: SubscriptionInfo;
  isPendingInjection?: boolean | undefined;
  hasAgrimaster?: boolean | undefined;
  hasWagemaster?: boolean | undefined;
  readonly licensingStatus?: string | undefined;
  readonly normalisationStatus?: string | undefined;
  lastLicenseInjectionAttemptStart?: moment.Moment | undefined;
  lastLicenseInjectionAttemptEnd?: moment.Moment | undefined;
  licenseInjectionAttemptCount?: number;
  isLicenseInjectionSuccessful?: boolean | undefined;
  payrollExternalId?: string | undefined;
  isNormalisationSuccessful?: boolean | undefined;
  projectColumnName?: string | undefined;

  constructor(data?: IBackupFile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.userOwnedBy = new Profile();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.userOwnedBy = _data['userOwnedBy'] ? Profile.fromJS(_data['userOwnedBy']) : new Profile();
      this.userSavedBy = _data['userSavedBy'] ? Profile.fromJS(_data['userSavedBy']) : <any>undefined;
      this.fileSize = _data['fileSize'];
      this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
      this.fileType = _data['fileType'];
      this.fileChecksum = _data['fileChecksum'];
      this.modifiedFileChecksum = _data['modifiedFileChecksum'];
      this.note = _data['note'];
      this.businessId = _data['businessId'];
      this.subscriptionId = _data['subscriptionId'];
      this.subscription = _data['subscription'] ? SubscriptionInfo.fromJS(_data['subscription']) : <any>undefined;
      this.isPendingInjection = _data['isPendingInjection'];
      this.hasAgrimaster = _data['hasAgrimaster'];
      this.hasWagemaster = _data['hasWagemaster'];
      (<any>this).licensingStatus = _data['licensingStatus'];
      (<any>this).normalisationStatus = _data['normalisationStatus'];
      this.lastLicenseInjectionAttemptStart = _data['lastLicenseInjectionAttemptStart'] ? moment(_data['lastLicenseInjectionAttemptStart'].toString()) : <any>undefined;
      this.lastLicenseInjectionAttemptEnd = _data['lastLicenseInjectionAttemptEnd'] ? moment(_data['lastLicenseInjectionAttemptEnd'].toString()) : <any>undefined;
      this.licenseInjectionAttemptCount = _data['licenseInjectionAttemptCount'];
      this.isLicenseInjectionSuccessful = _data['isLicenseInjectionSuccessful'];
      this.payrollExternalId = _data['payrollExternalId'];
      this.isNormalisationSuccessful = _data['isNormalisationSuccessful'];
      this.projectColumnName = _data['projectColumnName'];
    }
  }

  static fromJS(data: any): BackupFile {
    data = typeof data === 'object' ? data : {};
    let result = new BackupFile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['userOwnedBy'] = this.userOwnedBy ? this.userOwnedBy.toJSON() : <any>undefined;
    data['userSavedBy'] = this.userSavedBy ? this.userSavedBy.toJSON() : <any>undefined;
    data['fileSize'] = this.fileSize;
    data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
    data['fileType'] = this.fileType;
    data['fileChecksum'] = this.fileChecksum;
    data['modifiedFileChecksum'] = this.modifiedFileChecksum;
    data['note'] = this.note;
    data['businessId'] = this.businessId;
    data['subscriptionId'] = this.subscriptionId;
    data['subscription'] = this.subscription ? this.subscription.toJSON() : <any>undefined;
    data['isPendingInjection'] = this.isPendingInjection;
    data['hasAgrimaster'] = this.hasAgrimaster;
    data['hasWagemaster'] = this.hasWagemaster;
    data['licensingStatus'] = this.licensingStatus;
    data['normalisationStatus'] = this.normalisationStatus;
    data['lastLicenseInjectionAttemptStart'] = this.lastLicenseInjectionAttemptStart ? this.lastLicenseInjectionAttemptStart.toISOString() : <any>undefined;
    data['lastLicenseInjectionAttemptEnd'] = this.lastLicenseInjectionAttemptEnd ? this.lastLicenseInjectionAttemptEnd.toISOString() : <any>undefined;
    data['licenseInjectionAttemptCount'] = this.licenseInjectionAttemptCount;
    data['isLicenseInjectionSuccessful'] = this.isLicenseInjectionSuccessful;
    data['payrollExternalId'] = this.payrollExternalId;
    data['isNormalisationSuccessful'] = this.isNormalisationSuccessful;
    data['projectColumnName'] = this.projectColumnName;
    return data;
  }
}

export interface IBackupFile {
  id?: number | undefined;
  name: string;
  userOwnedBy: Profile;
  userSavedBy?: Profile;
  fileSize: number;
  modifiedDate: moment.Moment;
  fileType: BackupType;
  fileChecksum?: string | undefined;
  modifiedFileChecksum?: string | undefined;
  note?: string | undefined;
  businessId?: number;
  subscriptionId?: number | undefined;
  subscription?: SubscriptionInfo;
  isPendingInjection?: boolean | undefined;
  hasAgrimaster?: boolean | undefined;
  hasWagemaster?: boolean | undefined;
  licensingStatus?: string | undefined;
  normalisationStatus?: string | undefined;
  lastLicenseInjectionAttemptStart?: moment.Moment | undefined;
  lastLicenseInjectionAttemptEnd?: moment.Moment | undefined;
  licenseInjectionAttemptCount?: number;
  isLicenseInjectionSuccessful?: boolean | undefined;
  payrollExternalId?: string | undefined;
  isNormalisationSuccessful?: boolean | undefined;
  projectColumnName?: string | undefined;
}

export enum SharingPermissions {
  Read = 'read',
  ReadWrite = 'readWrite'
}

export class SharingPermission implements ISharingPermission {
  id?: number;
  userOwnedBy?: string | undefined;
  userSharedWith?: string | undefined;
  permissions?: SharingPermissions;

  constructor(data?: ISharingPermission) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userOwnedBy = _data['userOwnedBy'];
      this.userSharedWith = _data['userSharedWith'];
      this.permissions = _data['permissions'];
    }
  }

  static fromJS(data: any): SharingPermission {
    data = typeof data === 'object' ? data : {};
    let result = new SharingPermission();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userOwnedBy'] = this.userOwnedBy;
    data['userSharedWith'] = this.userSharedWith;
    data['permissions'] = this.permissions;
    return data;
  }
}

export interface ISharingPermission {
  id?: number;
  userOwnedBy?: string | undefined;
  userSharedWith?: string | undefined;
  permissions?: SharingPermissions;
}

export class BackupFileDetails implements IBackupFileDetails {
  summary!: BackupFile;
  revisions?: BackupFile[] | undefined;
  sharedWith?: SharingPermission[] | undefined;

  constructor(data?: IBackupFileDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.summary = new BackupFile();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.summary = _data['summary'] ? BackupFile.fromJS(_data['summary']) : new BackupFile();
      if (Array.isArray(_data['revisions'])) {
        this.revisions = [] as any;
        for (let item of _data['revisions']) this.revisions!.push(BackupFile.fromJS(item));
      }
      if (Array.isArray(_data['sharedWith'])) {
        this.sharedWith = [] as any;
        for (let item of _data['sharedWith']) this.sharedWith!.push(SharingPermission.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BackupFileDetails {
    data = typeof data === 'object' ? data : {};
    let result = new BackupFileDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['summary'] = this.summary ? this.summary.toJSON() : <any>undefined;
    if (Array.isArray(this.revisions)) {
      data['revisions'] = [];
      for (let item of this.revisions) data['revisions'].push(item.toJSON());
    }
    if (Array.isArray(this.sharedWith)) {
      data['sharedWith'] = [];
      for (let item of this.sharedWith) data['sharedWith'].push(item.toJSON());
    }
    return data;
  }
}

export interface IBackupFileDetails {
  summary: BackupFile;
  revisions?: BackupFile[] | undefined;
  sharedWith?: SharingPermission[] | undefined;
}

export class HelpLink implements IHelpLink {
  name?: string | undefined;
  area?: string | undefined;
  url?: string | undefined;

  constructor(data?: IHelpLink) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.area = _data['area'];
      this.url = _data['url'];
    }
  }

  static fromJS(data: any): HelpLink {
    data = typeof data === 'object' ? data : {};
    let result = new HelpLink();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['area'] = this.area;
    data['url'] = this.url;
    return data;
  }
}

export interface IHelpLink {
  name?: string | undefined;
  area?: string | undefined;
  url?: string | undefined;
}

export class ClientActivationResponse implements IClientActivationResponse {
  id?: number;
  softwareLicenseId?: number;
  softwareActivationKey?: string | undefined;
  manualActivationFlag?: boolean;
  activationDate?: moment.Moment;
  deleteChecksum?: string | undefined;

  constructor(data?: IClientActivationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.softwareLicenseId = _data['softwareLicenseId'];
      this.softwareActivationKey = _data['softwareActivationKey'];
      this.manualActivationFlag = _data['manualActivationFlag'];
      this.activationDate = _data['activationDate'] ? moment(_data['activationDate'].toString()) : <any>undefined;
      this.deleteChecksum = _data['deleteChecksum'];
    }
  }

  static fromJS(data: any): ClientActivationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientActivationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['softwareLicenseId'] = this.softwareLicenseId;
    data['softwareActivationKey'] = this.softwareActivationKey;
    data['manualActivationFlag'] = this.manualActivationFlag;
    data['activationDate'] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
    data['deleteChecksum'] = this.deleteChecksum;
    return data;
  }
}

export interface IClientActivationResponse {
  id?: number;
  softwareLicenseId?: number;
  softwareActivationKey?: string | undefined;
  manualActivationFlag?: boolean;
  activationDate?: moment.Moment;
  deleteChecksum?: string | undefined;
}

export class ClientLicenseResponse implements IClientLicenseResponse {
  activationExpiry?: moment.Moment;
  activationsAllowed?: number;
  perpetualLicenseFlag?: boolean;
  softwareSerialNumber?: string | undefined;

  constructor(data?: IClientLicenseResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activationExpiry = _data['activationExpiry'] ? moment(_data['activationExpiry'].toString()) : <any>undefined;
      this.activationsAllowed = _data['activationsAllowed'];
      this.perpetualLicenseFlag = _data['perpetualLicenseFlag'];
      this.softwareSerialNumber = _data['softwareSerialNumber'];
    }
  }

  static fromJS(data: any): ClientLicenseResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ClientLicenseResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activationExpiry'] = this.activationExpiry ? this.activationExpiry.toISOString() : <any>undefined;
    data['activationsAllowed'] = this.activationsAllowed;
    data['perpetualLicenseFlag'] = this.perpetualLicenseFlag;
    data['softwareSerialNumber'] = this.softwareSerialNumber;
    return data;
  }
}

export interface IClientLicenseResponse {
  activationExpiry?: moment.Moment;
  activationsAllowed?: number;
  perpetualLicenseFlag?: boolean;
  softwareSerialNumber?: string | undefined;
}

export class ActivationResponse implements IActivationResponse {
  softwareSerialNumber?: string | undefined;
  softwareActivationKey?: string | undefined;
  warningText?: string | undefined;
  perpetualLicenseFlag?: boolean;
  featureFlag?: number;

  constructor(data?: IActivationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.softwareSerialNumber = _data['softwareSerialNumber'];
      this.softwareActivationKey = _data['softwareActivationKey'];
      this.warningText = _data['warningText'];
      this.perpetualLicenseFlag = _data['perpetualLicenseFlag'];
      this.featureFlag = _data['featureFlag'];
    }
  }

  static fromJS(data: any): ActivationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActivationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['softwareSerialNumber'] = this.softwareSerialNumber;
    data['softwareActivationKey'] = this.softwareActivationKey;
    data['warningText'] = this.warningText;
    data['perpetualLicenseFlag'] = this.perpetualLicenseFlag;
    data['featureFlag'] = this.featureFlag;
    return data;
  }
}

export interface IActivationResponse {
  softwareSerialNumber?: string | undefined;
  softwareActivationKey?: string | undefined;
  warningText?: string | undefined;
  perpetualLicenseFlag?: boolean;
  featureFlag?: number;
}

export class ActivationAllowedResponse implements IActivationAllowedResponse {
  allowed?: boolean;
  overAllowedActivations?: boolean;
  allowedActivations?: number;
  currentActivations?: number;

  constructor(data?: IActivationAllowedResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowed = _data['allowed'];
      this.overAllowedActivations = _data['overAllowedActivations'];
      this.allowedActivations = _data['allowedActivations'];
      this.currentActivations = _data['currentActivations'];
    }
  }

  static fromJS(data: any): ActivationAllowedResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActivationAllowedResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['allowed'] = this.allowed;
    data['overAllowedActivations'] = this.overAllowedActivations;
    data['allowedActivations'] = this.allowedActivations;
    data['currentActivations'] = this.currentActivations;
    return data;
  }
}

export interface IActivationAllowedResponse {
  allowed?: boolean;
  overAllowedActivations?: boolean;
  allowedActivations?: number;
  currentActivations?: number;
}

export class UserDatumModel implements IUserDatumModel {
  key?: string | undefined;
  value?: string | undefined;

  constructor(data?: IUserDatumModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): UserDatumModel {
    data = typeof data === 'object' ? data : {};
    let result = new UserDatumModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['value'] = this.value;
    return data;
  }
}

export interface IUserDatumModel {
  key?: string | undefined;
  value?: string | undefined;
}

export enum LogLevel {
  Trace = 'trace',
  Debug = 'debug',
  Information = 'information',
  Warning = 'warning',
  Error = 'error',
  Critical = 'critical',
  None = 'none'
}

export class LogModel implements ILogModel {
  message?: string | undefined;
  logLevel?: LogLevel;
  clientServerId?: number;

  constructor(data?: ILogModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.message = _data['message'];
      this.logLevel = _data['logLevel'];
      this.clientServerId = _data['clientServerId'];
    }
  }

  static fromJS(data: any): LogModel {
    data = typeof data === 'object' ? data : {};
    let result = new LogModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['message'] = this.message;
    data['logLevel'] = this.logLevel;
    data['clientServerId'] = this.clientServerId;
    return data;
  }
}

export interface ILogModel {
  message?: string | undefined;
  logLevel?: LogLevel;
  clientServerId?: number;
}

export enum UpdateGroupType {
  Staff = 'staff',
  Edge = 'edge',
  Public = 'public'
}

export class ProductVersionInformation implements IProductVersionInformation {
  applicationName?: string | undefined;
  versionNumber?: string | undefined;
  fileVersionNumber?: string | undefined;

  constructor(data?: IProductVersionInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationName = _data['applicationName'];
      this.versionNumber = _data['versionNumber'];
      this.fileVersionNumber = _data['fileVersionNumber'];
    }
  }

  static fromJS(data: any): ProductVersionInformation {
    data = typeof data === 'object' ? data : {};
    let result = new ProductVersionInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['applicationName'] = this.applicationName;
    data['versionNumber'] = this.versionNumber;
    data['fileVersionNumber'] = this.fileVersionNumber;
    return data;
  }
}

export interface IProductVersionInformation {
  applicationName?: string | undefined;
  versionNumber?: string | undefined;
  fileVersionNumber?: string | undefined;
}

export class AntivirusInformation implements IAntivirusInformation {
  name?: string | undefined;

  constructor(data?: IAntivirusInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): AntivirusInformation {
    data = typeof data === 'object' ? data : {};
    let result = new AntivirusInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface IAntivirusInformation {
  name?: string | undefined;
}

export class SystemInformation implements ISystemInformation {
  clientServerId?: number;
  operatingSystem?: string | undefined;
  processorName?: string | undefined;
  patchVersion?: string | undefined;
  hardiskAvailableFreeSpace?: number;
  totalRam?: number;
  downloadSpeed?: number | undefined;
  uploadSpeed?: number | undefined;
  latency?: number | undefined;
  isFirewallEnabled?: boolean | undefined;
  releaseRing?: UpdateGroupType;
  productVersionInformations?: ProductVersionInformation[] | undefined;
  antivirusInformations?: AntivirusInformation[] | undefined;

  constructor(data?: ISystemInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientServerId = _data['clientServerId'];
      this.operatingSystem = _data['operatingSystem'];
      this.processorName = _data['processorName'];
      this.patchVersion = _data['patchVersion'];
      this.hardiskAvailableFreeSpace = _data['hardiskAvailableFreeSpace'];
      this.totalRam = _data['totalRam'];
      this.downloadSpeed = _data['downloadSpeed'];
      this.uploadSpeed = _data['uploadSpeed'];
      this.latency = _data['latency'];
      this.isFirewallEnabled = _data['isFirewallEnabled'];
      this.releaseRing = _data['releaseRing'];
      if (Array.isArray(_data['productVersionInformations'])) {
        this.productVersionInformations = [] as any;
        for (let item of _data['productVersionInformations']) this.productVersionInformations!.push(ProductVersionInformation.fromJS(item));
      }
      if (Array.isArray(_data['antivirusInformations'])) {
        this.antivirusInformations = [] as any;
        for (let item of _data['antivirusInformations']) this.antivirusInformations!.push(AntivirusInformation.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SystemInformation {
    data = typeof data === 'object' ? data : {};
    let result = new SystemInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientServerId'] = this.clientServerId;
    data['operatingSystem'] = this.operatingSystem;
    data['processorName'] = this.processorName;
    data['patchVersion'] = this.patchVersion;
    data['hardiskAvailableFreeSpace'] = this.hardiskAvailableFreeSpace;
    data['totalRam'] = this.totalRam;
    data['downloadSpeed'] = this.downloadSpeed;
    data['uploadSpeed'] = this.uploadSpeed;
    data['latency'] = this.latency;
    data['isFirewallEnabled'] = this.isFirewallEnabled;
    data['releaseRing'] = this.releaseRing;
    if (Array.isArray(this.productVersionInformations)) {
      data['productVersionInformations'] = [];
      for (let item of this.productVersionInformations) data['productVersionInformations'].push(item.toJSON());
    }
    if (Array.isArray(this.antivirusInformations)) {
      data['antivirusInformations'] = [];
      for (let item of this.antivirusInformations) data['antivirusInformations'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISystemInformation {
  clientServerId?: number;
  operatingSystem?: string | undefined;
  processorName?: string | undefined;
  patchVersion?: string | undefined;
  hardiskAvailableFreeSpace?: number;
  totalRam?: number;
  downloadSpeed?: number | undefined;
  uploadSpeed?: number | undefined;
  latency?: number | undefined;
  isFirewallEnabled?: boolean | undefined;
  releaseRing?: UpdateGroupType;
  productVersionInformations?: ProductVersionInformation[] | undefined;
  antivirusInformations?: AntivirusInformation[] | undefined;
}

export class NotificationModel implements INotificationModel {
  id?: number;
  notificationType?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  creation?: moment.Moment;
  modification?: moment.Moment | undefined;
  expiry?: moment.Moment | undefined;
  isRead?: boolean;

  constructor(data?: INotificationModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.notificationType = _data['notificationType'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.creation = _data['creation'] ? moment(_data['creation'].toString()) : <any>undefined;
      this.modification = _data['modification'] ? moment(_data['modification'].toString()) : <any>undefined;
      this.expiry = _data['expiry'] ? moment(_data['expiry'].toString()) : <any>undefined;
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): NotificationModel {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['notificationType'] = this.notificationType;
    data['title'] = this.title;
    data['description'] = this.description;
    data['creation'] = this.creation ? this.creation.toISOString() : <any>undefined;
    data['modification'] = this.modification ? this.modification.toISOString() : <any>undefined;
    data['expiry'] = this.expiry ? this.expiry.toISOString() : <any>undefined;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface INotificationModel {
  id?: number;
  notificationType?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  creation?: moment.Moment;
  modification?: moment.Moment | undefined;
  expiry?: moment.Moment | undefined;
  isRead?: boolean;
}

export class PayrollAccountModel implements IPayrollAccountModel {
  businessId?: number;
  apiKey?: string | undefined;
  payrollSetupLookupId?: number;
  payrollExternalId?: string | undefined;

  constructor(data?: IPayrollAccountModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.businessId = _data['businessId'];
      this.apiKey = _data['apiKey'];
      this.payrollSetupLookupId = _data['payrollSetupLookupId'];
      this.payrollExternalId = _data['payrollExternalId'];
    }
  }

  static fromJS(data: any): PayrollAccountModel {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollAccountModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['businessId'] = this.businessId;
    data['apiKey'] = this.apiKey;
    data['payrollSetupLookupId'] = this.payrollSetupLookupId;
    data['payrollExternalId'] = this.payrollExternalId;
    return data;
  }
}

export interface IPayrollAccountModel {
  businessId?: number;
  apiKey?: string | undefined;
  payrollSetupLookupId?: number;
  payrollExternalId?: string | undefined;
}

export class Code implements ICode {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  order?: number;

  constructor(data?: ICode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.businessId = _data['businessId'];
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): Code {
    data = typeof data === 'object' ? data : {};
    let result = new Code();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['businessId'] = this.businessId;
    data['order'] = this.order;
    return data;
  }
}

export interface ICode {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  order?: number;
}

export class Allocation implements IAllocation {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  order?: number;

  constructor(data?: IAllocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.businessId = _data['businessId'];
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): Allocation {
    data = typeof data === 'object' ? data : {};
    let result = new Allocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['businessId'] = this.businessId;
    data['order'] = this.order;
    return data;
  }
}

export interface IAllocation {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  order?: number;
}

export class Enterprise implements IEnterprise {
  id?: number;
  businessId?: number;
  name?: string | undefined;
  order?: number;

  constructor(data?: IEnterprise) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.businessId = _data['businessId'];
      this.name = _data['name'];
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): Enterprise {
    data = typeof data === 'object' ? data : {};
    let result = new Enterprise();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['businessId'] = this.businessId;
    data['name'] = this.name;
    data['order'] = this.order;
    return data;
  }
}

export interface IEnterprise {
  id?: number;
  businessId?: number;
  name?: string | undefined;
  order?: number;
}

export class Project implements IProject {
  id?: number;
  name?: string | undefined;
  businessId?: number;

  constructor(data?: IProject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.businessId = _data['businessId'];
    }
  }

  static fromJS(data: any): Project {
    data = typeof data === 'object' ? data : {};
    let result = new Project();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['businessId'] = this.businessId;
    return data;
  }
}

export interface IProject {
  id?: number;
  name?: string | undefined;
  businessId?: number;
}

export class PayrollAllowance implements IPayrollAllowance {
  name?: string | undefined;
  type?: string | undefined;
  code?: Code;
  codeId?: number | undefined;
  allocation?: Allocation;
  allocationId?: number | undefined;
  enterprise?: Enterprise;
  enterpriseId?: number | undefined;
  project?: Project;
  projectId?: number | undefined;

  constructor(data?: IPayrollAllowance) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.type = _data['type'];
      this.code = _data['code'] ? Code.fromJS(_data['code']) : <any>undefined;
      this.codeId = _data['codeId'];
      this.allocation = _data['allocation'] ? Allocation.fromJS(_data['allocation']) : <any>undefined;
      this.allocationId = _data['allocationId'];
      this.enterprise = _data['enterprise'] ? Enterprise.fromJS(_data['enterprise']) : <any>undefined;
      this.enterpriseId = _data['enterpriseId'];
      this.project = _data['project'] ? Project.fromJS(_data['project']) : <any>undefined;
      this.projectId = _data['projectId'];
    }
  }

  static fromJS(data: any): PayrollAllowance {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollAllowance();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['type'] = this.type;
    data['code'] = this.code ? this.code.toJSON() : <any>undefined;
    data['codeId'] = this.codeId;
    data['allocation'] = this.allocation ? this.allocation.toJSON() : <any>undefined;
    data['allocationId'] = this.allocationId;
    data['enterprise'] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
    data['enterpriseId'] = this.enterpriseId;
    data['project'] = this.project ? this.project.toJSON() : <any>undefined;
    data['projectId'] = this.projectId;
    return data;
  }
}

export interface IPayrollAllowance {
  name?: string | undefined;
  type?: string | undefined;
  code?: Code;
  codeId?: number | undefined;
  allocation?: Allocation;
  allocationId?: number | undefined;
  enterprise?: Enterprise;
  enterpriseId?: number | undefined;
  project?: Project;
  projectId?: number | undefined;
}

export class CodeGroup implements ICodeGroup {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  groups?: CodeGroup[] | undefined;
  codes?: Code[] | undefined;
  order?: number;

  constructor(data?: ICodeGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.businessId = _data['businessId'];
      if (Array.isArray(_data['groups'])) {
        this.groups = [] as any;
        for (let item of _data['groups']) this.groups!.push(CodeGroup.fromJS(item));
      }
      if (Array.isArray(_data['codes'])) {
        this.codes = [] as any;
        for (let item of _data['codes']) this.codes!.push(Code.fromJS(item));
      }
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): CodeGroup {
    data = typeof data === 'object' ? data : {};
    let result = new CodeGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['businessId'] = this.businessId;
    if (Array.isArray(this.groups)) {
      data['groups'] = [];
      for (let item of this.groups) data['groups'].push(item.toJSON());
    }
    if (Array.isArray(this.codes)) {
      data['codes'] = [];
      for (let item of this.codes) data['codes'].push(item.toJSON());
    }
    data['order'] = this.order;
    return data;
  }
}

export interface ICodeGroup {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  groups?: CodeGroup[] | undefined;
  codes?: Code[] | undefined;
  order?: number;
}

export class AllocationGroup implements IAllocationGroup {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  allocations?: Allocation[] | undefined;
  order?: number;

  constructor(data?: IAllocationGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.businessId = _data['businessId'];
      if (Array.isArray(_data['allocations'])) {
        this.allocations = [] as any;
        for (let item of _data['allocations']) this.allocations!.push(Allocation.fromJS(item));
      }
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): AllocationGroup {
    data = typeof data === 'object' ? data : {};
    let result = new AllocationGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['businessId'] = this.businessId;
    if (Array.isArray(this.allocations)) {
      data['allocations'] = [];
      for (let item of this.allocations) data['allocations'].push(item.toJSON());
    }
    data['order'] = this.order;
    return data;
  }
}

export interface IAllocationGroup {
  id?: number;
  name?: string | undefined;
  businessId?: number;
  allocations?: Allocation[] | undefined;
  order?: number;
}

export class PayrollEmployee implements IPayrollEmployee {
  firstName?: string | undefined;
  lastName?: string | undefined;
  middleName?: string | undefined;
  title?: string | undefined;
  hasBeenCreated?: boolean;
  isActive?: boolean;
  payrollId?: number | undefined;
  enterprise?: Enterprise;
  enterpriseId?: number | undefined;
  allocation?: Allocation;
  allocationId?: number | undefined;
  superannuationCode?: Code;
  superannuationCodeId?: number | undefined;
  wagesCode?: Code;
  wagesCodeId?: number | undefined;
  bankAccount?: BankAccount;
  bankAccountId?: number | undefined;
  project?: Project;
  projectId?: number | undefined;

  constructor(data?: IPayrollEmployee) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.middleName = _data['middleName'];
      this.title = _data['title'];
      this.hasBeenCreated = _data['hasBeenCreated'];
      this.isActive = _data['isActive'];
      this.payrollId = _data['payrollId'];
      this.enterprise = _data['enterprise'] ? Enterprise.fromJS(_data['enterprise']) : <any>undefined;
      this.enterpriseId = _data['enterpriseId'];
      this.allocation = _data['allocation'] ? Allocation.fromJS(_data['allocation']) : <any>undefined;
      this.allocationId = _data['allocationId'];
      this.superannuationCode = _data['superannuationCode'] ? Code.fromJS(_data['superannuationCode']) : <any>undefined;
      this.superannuationCodeId = _data['superannuationCodeId'];
      this.wagesCode = _data['wagesCode'] ? Code.fromJS(_data['wagesCode']) : <any>undefined;
      this.wagesCodeId = _data['wagesCodeId'];
      this.bankAccount = _data['bankAccount'] ? BankAccount.fromJS(_data['bankAccount']) : <any>undefined;
      this.bankAccountId = _data['bankAccountId'];
      this.project = _data['project'] ? Project.fromJS(_data['project']) : <any>undefined;
      this.projectId = _data['projectId'];
    }
  }

  static fromJS(data: any): PayrollEmployee {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollEmployee();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['middleName'] = this.middleName;
    data['title'] = this.title;
    data['hasBeenCreated'] = this.hasBeenCreated;
    data['isActive'] = this.isActive;
    data['payrollId'] = this.payrollId;
    data['enterprise'] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
    data['enterpriseId'] = this.enterpriseId;
    data['allocation'] = this.allocation ? this.allocation.toJSON() : <any>undefined;
    data['allocationId'] = this.allocationId;
    data['superannuationCode'] = this.superannuationCode ? this.superannuationCode.toJSON() : <any>undefined;
    data['superannuationCodeId'] = this.superannuationCodeId;
    data['wagesCode'] = this.wagesCode ? this.wagesCode.toJSON() : <any>undefined;
    data['wagesCodeId'] = this.wagesCodeId;
    data['bankAccount'] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
    data['bankAccountId'] = this.bankAccountId;
    data['project'] = this.project ? this.project.toJSON() : <any>undefined;
    data['projectId'] = this.projectId;
    return data;
  }
}

export interface IPayrollEmployee {
  firstName?: string | undefined;
  lastName?: string | undefined;
  middleName?: string | undefined;
  title?: string | undefined;
  hasBeenCreated?: boolean;
  isActive?: boolean;
  payrollId?: number | undefined;
  enterprise?: Enterprise;
  enterpriseId?: number | undefined;
  allocation?: Allocation;
  allocationId?: number | undefined;
  superannuationCode?: Code;
  superannuationCodeId?: number | undefined;
  wagesCode?: Code;
  wagesCodeId?: number | undefined;
  bankAccount?: BankAccount;
  bankAccountId?: number | undefined;
  project?: Project;
  projectId?: number | undefined;
}

export class PayrollSetupModel implements IPayrollSetupModel {
  monthInterval?: number;
  newEmployeeAllocationGroup?: AllocationGroup;
  newEmployeeAllocationGroupId?: number;
  defaultDebitBankAccount?: BankAccount;
  defaultDebitBankAccountId?: number;
  paymentSuspenseCode?: Code;
  paymentSuspenseCodeId?: number;
  superannuationCode?: Code;
  superannuationCodeId?: number;
  thirdPartyPaymentCode?: Code;
  thirdPartyPaymentCodeId?: number | undefined;
  employees?: PayrollEmployee[] | undefined;
  allowances?: PayrollAllowance[] | undefined;

  constructor(data?: IPayrollSetupModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.monthInterval = _data['monthInterval'];
      this.newEmployeeAllocationGroup = _data['newEmployeeAllocationGroup'] ? AllocationGroup.fromJS(_data['newEmployeeAllocationGroup']) : <any>undefined;
      this.newEmployeeAllocationGroupId = _data['newEmployeeAllocationGroupId'];
      this.defaultDebitBankAccount = _data['defaultDebitBankAccount'] ? BankAccount.fromJS(_data['defaultDebitBankAccount']) : <any>undefined;
      this.defaultDebitBankAccountId = _data['defaultDebitBankAccountId'];
      this.paymentSuspenseCode = _data['paymentSuspenseCode'] ? Code.fromJS(_data['paymentSuspenseCode']) : <any>undefined;
      this.paymentSuspenseCodeId = _data['paymentSuspenseCodeId'];
      this.superannuationCode = _data['superannuationCode'] ? Code.fromJS(_data['superannuationCode']) : <any>undefined;
      this.superannuationCodeId = _data['superannuationCodeId'];
      this.thirdPartyPaymentCode = _data['thirdPartyPaymentCode'] ? Code.fromJS(_data['thirdPartyPaymentCode']) : <any>undefined;
      this.thirdPartyPaymentCodeId = _data['thirdPartyPaymentCodeId'];
      if (Array.isArray(_data['employees'])) {
        this.employees = [] as any;
        for (let item of _data['employees']) this.employees!.push(PayrollEmployee.fromJS(item));
      }
      if (Array.isArray(_data['allowances'])) {
        this.allowances = [] as any;
        for (let item of _data['allowances']) this.allowances!.push(PayrollAllowance.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PayrollSetupModel {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollSetupModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['monthInterval'] = this.monthInterval;
    data['newEmployeeAllocationGroup'] = this.newEmployeeAllocationGroup ? this.newEmployeeAllocationGroup.toJSON() : <any>undefined;
    data['newEmployeeAllocationGroupId'] = this.newEmployeeAllocationGroupId;
    data['defaultDebitBankAccount'] = this.defaultDebitBankAccount ? this.defaultDebitBankAccount.toJSON() : <any>undefined;
    data['defaultDebitBankAccountId'] = this.defaultDebitBankAccountId;
    data['paymentSuspenseCode'] = this.paymentSuspenseCode ? this.paymentSuspenseCode.toJSON() : <any>undefined;
    data['paymentSuspenseCodeId'] = this.paymentSuspenseCodeId;
    data['superannuationCode'] = this.superannuationCode ? this.superannuationCode.toJSON() : <any>undefined;
    data['superannuationCodeId'] = this.superannuationCodeId;
    data['thirdPartyPaymentCode'] = this.thirdPartyPaymentCode ? this.thirdPartyPaymentCode.toJSON() : <any>undefined;
    data['thirdPartyPaymentCodeId'] = this.thirdPartyPaymentCodeId;
    if (Array.isArray(this.employees)) {
      data['employees'] = [];
      for (let item of this.employees) data['employees'].push(item.toJSON());
    }
    if (Array.isArray(this.allowances)) {
      data['allowances'] = [];
      for (let item of this.allowances) data['allowances'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPayrollSetupModel {
  monthInterval?: number;
  newEmployeeAllocationGroup?: AllocationGroup;
  newEmployeeAllocationGroupId?: number;
  defaultDebitBankAccount?: BankAccount;
  defaultDebitBankAccountId?: number;
  paymentSuspenseCode?: Code;
  paymentSuspenseCodeId?: number;
  superannuationCode?: Code;
  superannuationCodeId?: number;
  thirdPartyPaymentCode?: Code;
  thirdPartyPaymentCodeId?: number | undefined;
  employees?: PayrollEmployee[] | undefined;
  allowances?: PayrollAllowance[] | undefined;
}

export class PayrollConfigModel implements IPayrollConfigModel {
  codeGroups?: CodeGroup[] | undefined;
  allocationGroups?: AllocationGroup[] | undefined;
  enterprises?: Enterprise[] | undefined;
  projects?: Project[] | undefined;
  bankAccounts?: BankAccount[] | undefined;
  projectColumnName?: string | undefined;
  existingSetup?: PayrollSetupModel;

  constructor(data?: IPayrollConfigModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['codeGroups'])) {
        this.codeGroups = [] as any;
        for (let item of _data['codeGroups']) this.codeGroups!.push(CodeGroup.fromJS(item));
      }
      if (Array.isArray(_data['allocationGroups'])) {
        this.allocationGroups = [] as any;
        for (let item of _data['allocationGroups']) this.allocationGroups!.push(AllocationGroup.fromJS(item));
      }
      if (Array.isArray(_data['enterprises'])) {
        this.enterprises = [] as any;
        for (let item of _data['enterprises']) this.enterprises!.push(Enterprise.fromJS(item));
      }
      if (Array.isArray(_data['projects'])) {
        this.projects = [] as any;
        for (let item of _data['projects']) this.projects!.push(Project.fromJS(item));
      }
      if (Array.isArray(_data['bankAccounts'])) {
        this.bankAccounts = [] as any;
        for (let item of _data['bankAccounts']) this.bankAccounts!.push(BankAccount.fromJS(item));
      }
      this.projectColumnName = _data['projectColumnName'];
      this.existingSetup = _data['existingSetup'] ? PayrollSetupModel.fromJS(_data['existingSetup']) : <any>undefined;
    }
  }

  static fromJS(data: any): PayrollConfigModel {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollConfigModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.codeGroups)) {
      data['codeGroups'] = [];
      for (let item of this.codeGroups) data['codeGroups'].push(item.toJSON());
    }
    if (Array.isArray(this.allocationGroups)) {
      data['allocationGroups'] = [];
      for (let item of this.allocationGroups) data['allocationGroups'].push(item.toJSON());
    }
    if (Array.isArray(this.enterprises)) {
      data['enterprises'] = [];
      for (let item of this.enterprises) data['enterprises'].push(item.toJSON());
    }
    if (Array.isArray(this.projects)) {
      data['projects'] = [];
      for (let item of this.projects) data['projects'].push(item.toJSON());
    }
    if (Array.isArray(this.bankAccounts)) {
      data['bankAccounts'] = [];
      for (let item of this.bankAccounts) data['bankAccounts'].push(item.toJSON());
    }
    data['projectColumnName'] = this.projectColumnName;
    data['existingSetup'] = this.existingSetup ? this.existingSetup.toJSON() : <any>undefined;
    return data;
  }
}

export interface IPayrollConfigModel {
  codeGroups?: CodeGroup[] | undefined;
  allocationGroups?: AllocationGroup[] | undefined;
  enterprises?: Enterprise[] | undefined;
  projects?: Project[] | undefined;
  bankAccounts?: BankAccount[] | undefined;
  projectColumnName?: string | undefined;
  existingSetup?: PayrollSetupModel;
}

export class TransactionDocument implements ITransactionDocument {
  transactionId?: number;
  documentType?: DocumentType;
  uploadTimestamp?: moment.Moment;
  fileName?: string | undefined;
  fileSize?: number;
  checksum?: string | undefined;

  constructor(data?: ITransactionDocument) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data['transactionId'];
      this.documentType = _data['documentType'];
      this.uploadTimestamp = _data['uploadTimestamp'] ? moment(_data['uploadTimestamp'].toString()) : <any>undefined;
      this.fileName = _data['fileName'];
      this.fileSize = _data['fileSize'];
      this.checksum = _data['checksum'];
    }
  }

  static fromJS(data: any): TransactionDocument {
    data = typeof data === 'object' ? data : {};
    let result = new TransactionDocument();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['transactionId'] = this.transactionId;
    data['documentType'] = this.documentType;
    data['uploadTimestamp'] = this.uploadTimestamp ? this.uploadTimestamp.toISOString() : <any>undefined;
    data['fileName'] = this.fileName;
    data['fileSize'] = this.fileSize;
    data['checksum'] = this.checksum;
    return data;
  }
}

export interface ITransactionDocument {
  transactionId?: number;
  documentType?: DocumentType;
  uploadTimestamp?: moment.Moment;
  fileName?: string | undefined;
  fileSize?: number;
  checksum?: string | undefined;
}

export class Split implements ISplit {
  id?: number;
  transactionId?: number | undefined;
  number?: number | undefined;
  codeId?: number | undefined;
  code?: Code;
  enterpriseId?: number | undefined;
  enterprise?: Enterprise;
  allocationId?: number | undefined;
  allocation?: Allocation;
  quantity?: number | undefined;
  description?: string | undefined;
  amount?: number | undefined;
  invoiceTypeLookupId?: number | undefined;
  invoiceTypeLookupValue?: string | undefined;
  orderNumber?: string | undefined;
  supplierInvoiceNumber?: string | undefined;
  gstIncudeExcludeLookupId?: number | undefined;
  gstIncudeExcludeLookupValue?: string | undefined;
  gstCategoryLookupId?: number | undefined;
  gstCategoryLookupValue?: string | undefined;
  gstInvoiceDate?: moment.Moment | undefined;
  gstRate?: number | undefined;
  gstAmount?: number | undefined;
  splitNet?: number | undefined;
  splitGross?: number | undefined;
  splitGstTypeLookupId?: number | undefined;
  splitGstTypeLookupValue?: string | undefined;
  locked?: boolean;
  gstCategoryOverrideLookupId?: number | undefined;
  gstCategoryOverrideLookupValue?: string | undefined;
  wineEqualizationTaxMethodLookupId?: number | undefined;
  wineEqualizationTaxMethodLookupValue?: string | undefined;
  retailValue?: number | undefined;
  wineEqualizationTaxCalculated?: number | undefined;
  importBatchLookupId?: number | undefined;
  importBatchLookupValue?: string | undefined;
  unitId?: number | undefined;
  unitValue?: string | undefined;
  originalSplitNumber?: number | undefined;
  projectId?: number | undefined;
  project?: Project;
  fuelDeliveryDate?: moment.Moment | undefined;

  constructor(data?: ISplit) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.transactionId = _data['transactionId'];
      this.number = _data['number'];
      this.codeId = _data['codeId'];
      this.code = _data['code'] ? Code.fromJS(_data['code']) : <any>undefined;
      this.enterpriseId = _data['enterpriseId'];
      this.enterprise = _data['enterprise'] ? Enterprise.fromJS(_data['enterprise']) : <any>undefined;
      this.allocationId = _data['allocationId'];
      this.allocation = _data['allocation'] ? Allocation.fromJS(_data['allocation']) : <any>undefined;
      this.quantity = _data['quantity'];
      this.description = _data['description'];
      this.amount = _data['amount'];
      this.invoiceTypeLookupId = _data['invoiceTypeLookupId'];
      this.invoiceTypeLookupValue = _data['invoiceTypeLookupValue'];
      this.orderNumber = _data['orderNumber'];
      this.supplierInvoiceNumber = _data['supplierInvoiceNumber'];
      this.gstIncudeExcludeLookupId = _data['gstIncudeExcludeLookupId'];
      this.gstIncudeExcludeLookupValue = _data['gstIncudeExcludeLookupValue'];
      this.gstCategoryLookupId = _data['gstCategoryLookupId'];
      this.gstCategoryLookupValue = _data['gstCategoryLookupValue'];
      this.gstInvoiceDate = _data['gstInvoiceDate'] ? moment(_data['gstInvoiceDate'].toString()) : <any>undefined;
      this.gstRate = _data['gstRate'];
      this.gstAmount = _data['gstAmount'];
      this.splitNet = _data['splitNet'];
      this.splitGross = _data['splitGross'];
      this.splitGstTypeLookupId = _data['splitGstTypeLookupId'];
      this.splitGstTypeLookupValue = _data['splitGstTypeLookupValue'];
      this.locked = _data['locked'];
      this.gstCategoryOverrideLookupId = _data['gstCategoryOverrideLookupId'];
      this.gstCategoryOverrideLookupValue = _data['gstCategoryOverrideLookupValue'];
      this.wineEqualizationTaxMethodLookupId = _data['wineEqualizationTaxMethodLookupId'];
      this.wineEqualizationTaxMethodLookupValue = _data['wineEqualizationTaxMethodLookupValue'];
      this.retailValue = _data['retailValue'];
      this.wineEqualizationTaxCalculated = _data['wineEqualizationTaxCalculated'];
      this.importBatchLookupId = _data['importBatchLookupId'];
      this.importBatchLookupValue = _data['importBatchLookupValue'];
      this.unitId = _data['unitId'];
      this.unitValue = _data['unitValue'];
      this.originalSplitNumber = _data['originalSplitNumber'];
      this.projectId = _data['projectId'];
      this.project = _data['project'] ? Project.fromJS(_data['project']) : <any>undefined;
      this.fuelDeliveryDate = _data['fuelDeliveryDate'] ? moment(_data['fuelDeliveryDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): Split {
    data = typeof data === 'object' ? data : {};
    let result = new Split();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['transactionId'] = this.transactionId;
    data['number'] = this.number;
    data['codeId'] = this.codeId;
    data['code'] = this.code ? this.code.toJSON() : <any>undefined;
    data['enterpriseId'] = this.enterpriseId;
    data['enterprise'] = this.enterprise ? this.enterprise.toJSON() : <any>undefined;
    data['allocationId'] = this.allocationId;
    data['allocation'] = this.allocation ? this.allocation.toJSON() : <any>undefined;
    data['quantity'] = this.quantity;
    data['description'] = this.description;
    data['amount'] = this.amount;
    data['invoiceTypeLookupId'] = this.invoiceTypeLookupId;
    data['invoiceTypeLookupValue'] = this.invoiceTypeLookupValue;
    data['orderNumber'] = this.orderNumber;
    data['supplierInvoiceNumber'] = this.supplierInvoiceNumber;
    data['gstIncudeExcludeLookupId'] = this.gstIncudeExcludeLookupId;
    data['gstIncudeExcludeLookupValue'] = this.gstIncudeExcludeLookupValue;
    data['gstCategoryLookupId'] = this.gstCategoryLookupId;
    data['gstCategoryLookupValue'] = this.gstCategoryLookupValue;
    data['gstInvoiceDate'] = this.gstInvoiceDate ? this.gstInvoiceDate.toISOString() : <any>undefined;
    data['gstRate'] = this.gstRate;
    data['gstAmount'] = this.gstAmount;
    data['splitNet'] = this.splitNet;
    data['splitGross'] = this.splitGross;
    data['splitGstTypeLookupId'] = this.splitGstTypeLookupId;
    data['splitGstTypeLookupValue'] = this.splitGstTypeLookupValue;
    data['locked'] = this.locked;
    data['gstCategoryOverrideLookupId'] = this.gstCategoryOverrideLookupId;
    data['gstCategoryOverrideLookupValue'] = this.gstCategoryOverrideLookupValue;
    data['wineEqualizationTaxMethodLookupId'] = this.wineEqualizationTaxMethodLookupId;
    data['wineEqualizationTaxMethodLookupValue'] = this.wineEqualizationTaxMethodLookupValue;
    data['retailValue'] = this.retailValue;
    data['wineEqualizationTaxCalculated'] = this.wineEqualizationTaxCalculated;
    data['importBatchLookupId'] = this.importBatchLookupId;
    data['importBatchLookupValue'] = this.importBatchLookupValue;
    data['unitId'] = this.unitId;
    data['unitValue'] = this.unitValue;
    data['originalSplitNumber'] = this.originalSplitNumber;
    data['projectId'] = this.projectId;
    data['project'] = this.project ? this.project.toJSON() : <any>undefined;
    data['fuelDeliveryDate'] = this.fuelDeliveryDate ? this.fuelDeliveryDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface ISplit {
  id?: number;
  transactionId?: number | undefined;
  number?: number | undefined;
  codeId?: number | undefined;
  code?: Code;
  enterpriseId?: number | undefined;
  enterprise?: Enterprise;
  allocationId?: number | undefined;
  allocation?: Allocation;
  quantity?: number | undefined;
  description?: string | undefined;
  amount?: number | undefined;
  invoiceTypeLookupId?: number | undefined;
  invoiceTypeLookupValue?: string | undefined;
  orderNumber?: string | undefined;
  supplierInvoiceNumber?: string | undefined;
  gstIncudeExcludeLookupId?: number | undefined;
  gstIncudeExcludeLookupValue?: string | undefined;
  gstCategoryLookupId?: number | undefined;
  gstCategoryLookupValue?: string | undefined;
  gstInvoiceDate?: moment.Moment | undefined;
  gstRate?: number | undefined;
  gstAmount?: number | undefined;
  splitNet?: number | undefined;
  splitGross?: number | undefined;
  splitGstTypeLookupId?: number | undefined;
  splitGstTypeLookupValue?: string | undefined;
  locked?: boolean;
  gstCategoryOverrideLookupId?: number | undefined;
  gstCategoryOverrideLookupValue?: string | undefined;
  wineEqualizationTaxMethodLookupId?: number | undefined;
  wineEqualizationTaxMethodLookupValue?: string | undefined;
  retailValue?: number | undefined;
  wineEqualizationTaxCalculated?: number | undefined;
  importBatchLookupId?: number | undefined;
  importBatchLookupValue?: string | undefined;
  unitId?: number | undefined;
  unitValue?: string | undefined;
  originalSplitNumber?: number | undefined;
  projectId?: number | undefined;
  project?: Project;
  fuelDeliveryDate?: moment.Moment | undefined;
}

export class Transaction implements ITransaction {
  transactionId?: number;
  businessId?: number;
  reference?: string | undefined;
  contactName?: string | undefined;
  bankAccountId?: number;
  bankName?: string | undefined;
  transactionDate?: moment.Moment;
  splits?: number | undefined;
  debit?: number;
  credit?: number;
  batchPrefix?: string | undefined;
  batchNumber?: string | undefined;
  total?: number;
  transactionDocuments?: TransactionDocument[] | undefined;
  splitValues?: Split[] | undefined;
  hasError?: boolean;
  errorMessage?: string | undefined;

  constructor(data?: ITransaction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data['transactionId'];
      this.businessId = _data['businessId'];
      this.reference = _data['reference'];
      this.contactName = _data['contactName'];
      this.bankAccountId = _data['bankAccountId'];
      this.bankName = _data['bankName'];
      this.transactionDate = _data['transactionDate'] ? moment(_data['transactionDate'].toString()) : <any>undefined;
      this.splits = _data['splits'];
      this.debit = _data['debit'];
      this.credit = _data['credit'];
      this.batchPrefix = _data['batchPrefix'];
      this.batchNumber = _data['batchNumber'];
      this.total = _data['total'];
      if (Array.isArray(_data['transactionDocuments'])) {
        this.transactionDocuments = [] as any;
        for (let item of _data['transactionDocuments']) this.transactionDocuments!.push(TransactionDocument.fromJS(item));
      }
      if (Array.isArray(_data['splitValues'])) {
        this.splitValues = [] as any;
        for (let item of _data['splitValues']) this.splitValues!.push(Split.fromJS(item));
      }
      this.hasError = _data['hasError'];
      this.errorMessage = _data['errorMessage'];
    }
  }

  static fromJS(data: any): Transaction {
    data = typeof data === 'object' ? data : {};
    let result = new Transaction();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['transactionId'] = this.transactionId;
    data['businessId'] = this.businessId;
    data['reference'] = this.reference;
    data['contactName'] = this.contactName;
    data['bankAccountId'] = this.bankAccountId;
    data['bankName'] = this.bankName;
    data['transactionDate'] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
    data['splits'] = this.splits;
    data['debit'] = this.debit;
    data['credit'] = this.credit;
    data['batchPrefix'] = this.batchPrefix;
    data['batchNumber'] = this.batchNumber;
    data['total'] = this.total;
    if (Array.isArray(this.transactionDocuments)) {
      data['transactionDocuments'] = [];
      for (let item of this.transactionDocuments) data['transactionDocuments'].push(item.toJSON());
    }
    if (Array.isArray(this.splitValues)) {
      data['splitValues'] = [];
      for (let item of this.splitValues) data['splitValues'].push(item.toJSON());
    }
    data['hasError'] = this.hasError;
    data['errorMessage'] = this.errorMessage;
    return data;
  }
}

export interface ITransaction {
  transactionId?: number;
  businessId?: number;
  reference?: string | undefined;
  contactName?: string | undefined;
  bankAccountId?: number;
  bankName?: string | undefined;
  transactionDate?: moment.Moment;
  splits?: number | undefined;
  debit?: number;
  credit?: number;
  batchPrefix?: string | undefined;
  batchNumber?: string | undefined;
  total?: number;
  transactionDocuments?: TransactionDocument[] | undefined;
  splitValues?: Split[] | undefined;
  hasError?: boolean;
  errorMessage?: string | undefined;
}

export class PayrollPayRun implements IPayrollPayRun {
  dateFinalised?: moment.Moment | undefined;
  datePaid?: moment.Moment;
  externalId?: string | undefined;
  isFinalised?: boolean;
  payPeriodEnding?: moment.Moment;
  payPeriodStarting?: moment.Moment;
  paySlipsPublished?: boolean;

  constructor(data?: IPayrollPayRun) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dateFinalised = _data['dateFinalised'] ? moment(_data['dateFinalised'].toString()) : <any>undefined;
      this.datePaid = _data['datePaid'] ? moment(_data['datePaid'].toString()) : <any>undefined;
      this.externalId = _data['externalId'];
      this.isFinalised = _data['isFinalised'];
      this.payPeriodEnding = _data['payPeriodEnding'] ? moment(_data['payPeriodEnding'].toString()) : <any>undefined;
      this.payPeriodStarting = _data['payPeriodStarting'] ? moment(_data['payPeriodStarting'].toString()) : <any>undefined;
      this.paySlipsPublished = _data['paySlipsPublished'];
    }
  }

  static fromJS(data: any): PayrollPayRun {
    data = typeof data === 'object' ? data : {};
    let result = new PayrollPayRun();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['dateFinalised'] = this.dateFinalised ? this.dateFinalised.toISOString() : <any>undefined;
    data['datePaid'] = this.datePaid ? this.datePaid.toISOString() : <any>undefined;
    data['externalId'] = this.externalId;
    data['isFinalised'] = this.isFinalised;
    data['payPeriodEnding'] = this.payPeriodEnding ? this.payPeriodEnding.toISOString() : <any>undefined;
    data['payPeriodStarting'] = this.payPeriodStarting ? this.payPeriodStarting.toISOString() : <any>undefined;
    data['paySlipsPublished'] = this.paySlipsPublished;
    return data;
  }
}

export interface IPayrollPayRun {
  dateFinalised?: moment.Moment | undefined;
  datePaid?: moment.Moment;
  externalId?: string | undefined;
  isFinalised?: boolean;
  payPeriodEnding?: moment.Moment;
  payPeriodStarting?: moment.Moment;
  paySlipsPublished?: boolean;
}

export class UserProfile implements IUserProfile {
  profileId?: number;
  userId?: number;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  emailAddress?: string | undefined;
  userType?: string | undefined;
  planExpiry?: moment.Moment | undefined;
  userExpiry?: moment.Moment | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  mobile?: string | undefined;
  edition?: string | undefined;
  modificationDate?: moment.Moment;
  readonly isActive?: boolean;
  voiceToken?: string | undefined;
  userToken?: string | undefined;
  isNewUser?: boolean;
  isAgs7User?: boolean;

  constructor(data?: IUserProfile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profileId = _data['profileId'];
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.companyName = _data['companyName'];
      this.abn = _data['abn'];
      this.emailAddress = _data['emailAddress'];
      this.userType = _data['userType'];
      this.planExpiry = _data['planExpiry'] ? moment(_data['planExpiry'].toString()) : <any>undefined;
      this.userExpiry = _data['userExpiry'] ? moment(_data['userExpiry'].toString()) : <any>undefined;
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.city = _data['city'];
      this.state = _data['state'];
      this.postcode = _data['postcode'];
      this.phone = _data['phone'];
      this.fax = _data['fax'];
      this.mobile = _data['mobile'];
      this.edition = _data['edition'];
      this.modificationDate = _data['modificationDate'] ? moment(_data['modificationDate'].toString()) : <any>undefined;
      (<any>this).isActive = _data['isActive'];
      this.voiceToken = _data['voiceToken'];
      this.userToken = _data['userToken'];
      this.isNewUser = _data['isNewUser'];
      this.isAgs7User = _data['isAgs7User'];
    }
  }

  static fromJS(data: any): UserProfile {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profileId'] = this.profileId;
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['companyName'] = this.companyName;
    data['abn'] = this.abn;
    data['emailAddress'] = this.emailAddress;
    data['userType'] = this.userType;
    data['planExpiry'] = this.planExpiry ? this.planExpiry.toISOString() : <any>undefined;
    data['userExpiry'] = this.userExpiry ? this.userExpiry.toISOString() : <any>undefined;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['city'] = this.city;
    data['state'] = this.state;
    data['postcode'] = this.postcode;
    data['phone'] = this.phone;
    data['fax'] = this.fax;
    data['mobile'] = this.mobile;
    data['edition'] = this.edition;
    data['modificationDate'] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
    data['isActive'] = this.isActive;
    data['voiceToken'] = this.voiceToken;
    data['userToken'] = this.userToken;
    data['isNewUser'] = this.isNewUser;
    data['isAgs7User'] = this.isAgs7User;
    return data;
  }
}

export interface IUserProfile {
  profileId?: number;
  userId?: number;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  emailAddress?: string | undefined;
  userType?: string | undefined;
  planExpiry?: moment.Moment | undefined;
  userExpiry?: moment.Moment | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
  phone?: string | undefined;
  fax?: string | undefined;
  mobile?: string | undefined;
  edition?: string | undefined;
  modificationDate?: moment.Moment;
  isActive?: boolean;
  voiceToken?: string | undefined;
  userToken?: string | undefined;
  isNewUser?: boolean;
  isAgs7User?: boolean;
}

export class PasswordResetResponse implements IPasswordResetResponse {
  userName?: string | undefined;
  password?: string | undefined;
  phonetic?: string | undefined;

  constructor(data?: IPasswordResetResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.phonetic = _data['phonetic'];
    }
  }

  static fromJS(data: any): PasswordResetResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordResetResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['phonetic'] = this.phonetic;
    return data;
  }
}

export interface IPasswordResetResponse {
  userName?: string | undefined;
  password?: string | undefined;
  phonetic?: string | undefined;
}

export class PasswordChangeRequest implements IPasswordChangeRequest {
  oldPassword?: string | undefined;
  newPassword?: string | undefined;

  constructor(data?: IPasswordChangeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.oldPassword = _data['oldPassword'];
      this.newPassword = _data['newPassword'];
    }
  }

  static fromJS(data: any): PasswordChangeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordChangeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['oldPassword'] = this.oldPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }
}

export interface IPasswordChangeRequest {
  oldPassword?: string | undefined;
  newPassword?: string | undefined;
}

export class ShopProduct implements IShopProduct {
  name?: string | undefined;
  image?: string | undefined;
  price?: number;
  code?: string | undefined;
  stripeId?: string | undefined;

  constructor(data?: IShopProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.image = _data['image'];
      this.price = _data['price'];
      this.code = _data['code'];
      this.stripeId = _data['stripeId'];
    }
  }

  static fromJS(data: any): ShopProduct {
    data = typeof data === 'object' ? data : {};
    let result = new ShopProduct();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['image'] = this.image;
    data['price'] = this.price;
    data['code'] = this.code;
    data['stripeId'] = this.stripeId;
    return data;
  }
}

export interface IShopProduct {
  name?: string | undefined;
  image?: string | undefined;
  price?: number;
  code?: string | undefined;
  stripeId?: string | undefined;
}

export class SubscriptionRequest implements ISubscriptionRequest {
  subscriberUserName?: string | undefined;
  planCode?: string | undefined;
  paymentMethodId?: string | undefined;
  abn?: string | undefined;
  entityName?: string | undefined;
  businessName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postCode?: string | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  businessId?: number;
  billingId?: string | undefined;
  subscriptionId?: number | undefined;
  onBehalfOfClient?: boolean;
  files?: string[] | undefined;
  requiresFile?: boolean;
  requiresSetup?: boolean;
  hasFreeTrial?: boolean;
  coupon?: string | undefined;
  prorataStartDate?: moment.Moment;
  primarySubscriptionId?: number;
  ags7UserId?: number;

  constructor(data?: ISubscriptionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subscriberUserName = _data['subscriberUserName'];
      this.planCode = _data['planCode'];
      this.paymentMethodId = _data['paymentMethodId'];
      this.abn = _data['abn'];
      this.entityName = _data['entityName'];
      this.businessName = _data['businessName'];
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.city = _data['city'];
      this.state = _data['state'];
      this.postCode = _data['postCode'];
      this.contactName = _data['contactName'];
      this.contactPhone = _data['contactPhone'];
      this.contactEmail = _data['contactEmail'];
      this.businessId = _data['businessId'];
      this.billingId = _data['billingId'];
      this.subscriptionId = _data['subscriptionId'];
      this.onBehalfOfClient = _data['onBehalfOfClient'];
      if (Array.isArray(_data['files'])) {
        this.files = [] as any;
        for (let item of _data['files']) this.files!.push(item);
      }
      this.requiresFile = _data['requiresFile'];
      this.requiresSetup = _data['requiresSetup'];
      this.hasFreeTrial = _data['hasFreeTrial'];
      this.coupon = _data['coupon'];
      this.prorataStartDate = _data['prorataStartDate'] ? moment(_data['prorataStartDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): SubscriptionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SubscriptionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['subscriberUserName'] = this.subscriberUserName;
    data['planCode'] = this.planCode;
    data['paymentMethodId'] = this.paymentMethodId;
    data['abn'] = this.abn;
    data['entityName'] = this.entityName;
    data['businessName'] = this.businessName;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['city'] = this.city;
    data['state'] = this.state;
    data['postCode'] = this.postCode;
    data['contactName'] = this.contactName;
    data['contactPhone'] = this.contactPhone;
    data['contactEmail'] = this.contactEmail;
    data['businessId'] = this.businessId;
    data['billingId'] = this.billingId;
    data['subscriptionId'] = this.subscriptionId;
    data['onBehalfOfClient'] = this.onBehalfOfClient;
    if (Array.isArray(this.files)) {
      data['files'] = [];
      for (let item of this.files) data['files'].push(item);
    }
    data['requiresFile'] = this.requiresFile;
    data['requiresSetup'] = this.requiresSetup;
    data['hasFreeTrial'] = this.hasFreeTrial;
    data['coupon'] = this.coupon;
    data['prorataStartDate'] = this.prorataStartDate ? this.prorataStartDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface ISubscriptionRequest {
  subscriberUserName?: string | undefined;
  planCode?: string | undefined;
  paymentMethodId?: string | undefined;
  abn?: string | undefined;
  entityName?: string | undefined;
  businessName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postCode?: string | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  businessId?: number;
  billingId?: string | undefined;
  subscriptionId?: number | undefined;
  onBehalfOfClient?: boolean;
  files?: string[] | undefined;
  requiresFile?: boolean;
  requiresSetup?: boolean;
  hasFreeTrial?: boolean;
  coupon?: string | undefined;
  prorataStartDate?: moment.Moment;
}

export class SubscriptionResponse implements ISubscriptionResponse {
  status?: string | undefined;
  clientSecret?: string | undefined;
  billingId?: string | undefined;
  subscriptionId?: number;
  invoiceUrl?: string | undefined;

  constructor(data?: ISubscriptionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.clientSecret = _data['clientSecret'];
      this.billingId = _data['billingId'];
      this.subscriptionId = _data['subscriptionId'];
      this.invoiceUrl = _data['invoiceUrl'];
    }
  }

  static fromJS(data: any): SubscriptionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SubscriptionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['clientSecret'] = this.clientSecret;
    data['billingId'] = this.billingId;
    data['subscriptionId'] = this.subscriptionId;
    data['invoiceUrl'] = this.invoiceUrl;
    return data;
  }
}

export interface ISubscriptionResponse {
  status?: string | undefined;
  clientSecret?: string | undefined;
  billingId?: string | undefined;
  subscriptionId?: number;
  invoiceUrl?: string | undefined;
}

export class ProRataDetails implements IProRataDetails {
  discountAmount?: number;
  owingAmount?: number;
  name?: string | undefined;
  prorataStartDate?: moment.Moment;
  couponApplied?: ShopCoupon;
  isProRata?: boolean;

  constructor(data?: IProRataDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.discountAmount = _data['discountAmount'];
      this.owingAmount = _data['owingAmount'];
      this.name = _data['name'];
      this.prorataStartDate = _data['prorataStartDate'] ? moment(_data['prorataStartDate'].toString()) : <any>undefined;
      this.couponApplied = _data['couponApplied'] ? ShopCoupon.fromJS(_data['couponApplied']) : <any>undefined;
      this.isProRata = _data['isProRata'];
    }
  }

  static fromJS(data: any): ProRataDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProRataDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['discountAmount'] = this.discountAmount;
    data['owingAmount'] = this.owingAmount;
    data['name'] = this.name;
    data['prorataStartDate'] = this.prorataStartDate ? this.prorataStartDate.toISOString() : <any>undefined;
    data['couponApplied'] = this.couponApplied ? this.couponApplied.toJSON() : <any>undefined;
    data['isProRata'] = this.isProRata;
    return data;
  }
}

export interface IProRataDetails {
  discountAmount?: number;
  owingAmount?: number;
  name?: string | undefined;
  prorataStartDate?: moment.Moment;
  couponApplied?: ShopCoupon;
  isProRata?: boolean;
}

export class BillingPortalSession implements IBillingPortalSession {
  id?: string | undefined;
  portalUrl?: string | undefined;

  constructor(data?: IBillingPortalSession) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.portalUrl = _data['portalUrl'];
    }
  }

  static fromJS(data: any): BillingPortalSession {
    data = typeof data === 'object' ? data : {};
    let result = new BillingPortalSession();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['portalUrl'] = this.portalUrl;
    return data;
  }
}

export interface IBillingPortalSession {
  id?: string | undefined;
  portalUrl?: string | undefined;
}

export class PasswordResponseModel implements IPasswordResponseModel {
  password?: string | undefined;
  generatedAt?: moment.Moment;

  constructor(data?: IPasswordResponseModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password'];
      this.generatedAt = _data['generatedAt'] ? moment(_data['generatedAt'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): PasswordResponseModel {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordResponseModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['password'] = this.password;
    data['generatedAt'] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
    return data;
  }
}

export interface IPasswordResponseModel {
  password?: string | undefined;
  generatedAt?: moment.Moment;
}

export class SystemUpdaterFileInformation implements ISystemUpdaterFileInformation {
  md5?: string | undefined;
  fullName?: string | undefined;
  skip?: boolean;

  constructor(data?: ISystemUpdaterFileInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.md5 = _data['md5'];
      this.fullName = _data['fullName'];
      this.skip = _data['skip'];
    }
  }

  static fromJS(data: any): SystemUpdaterFileInformation {
    data = typeof data === 'object' ? data : {};
    let result = new SystemUpdaterFileInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['md5'] = this.md5;
    data['fullName'] = this.fullName;
    data['skip'] = this.skip;
    return data;
  }
}

export interface ISystemUpdaterFileInformation {
  md5?: string | undefined;
  fullName?: string | undefined;
  skip?: boolean;
}

export class NewUserGuidResponse implements INewUserGuidResponse {
  guid?: string | undefined;
  registrationCodeExpiryInSeconds?: number;

  constructor(data?: INewUserGuidResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.guid = _data['guid'];
      this.registrationCodeExpiryInSeconds = _data['registrationCodeExpiryInSeconds'];
    }
  }

  static fromJS(data: any): NewUserGuidResponse {
    data = typeof data === 'object' ? data : {};
    let result = new NewUserGuidResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['guid'] = this.guid;
    data['registrationCodeExpiryInSeconds'] = this.registrationCodeExpiryInSeconds;
    return data;
  }
}

export interface INewUserGuidResponse {
  guid?: string | undefined;
  registrationCodeExpiryInSeconds?: number;
}

export class EmailRequest implements IEmailRequest {
  emailAddress?: string | undefined;

  constructor(data?: IEmailRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
    }
  }

  static fromJS(data: any): EmailRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EmailRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    return data;
  }
}

export interface IEmailRequest {
  emailAddress?: string | undefined;
}

export class RegistrationCodeRequest implements IRegistrationCodeRequest {
  emailAddress?: string | undefined;
  registrationCode?: string | undefined;
  guid?: string | undefined;

  constructor(data?: IRegistrationCodeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
      this.registrationCode = _data['registrationCode'];
      this.guid = _data['guid'];
    }
  }

  static fromJS(data: any): RegistrationCodeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RegistrationCodeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    data['registrationCode'] = this.registrationCode;
    data['guid'] = this.guid;
    return data;
  }
}

export interface IRegistrationCodeRequest {
  emailAddress?: string | undefined;
  registrationCode?: string | undefined;
  guid?: string | undefined;
}

export class UserAccountRequest implements IUserAccountRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  emailAddress?: string | undefined;
  emailConfirmed?: boolean;
  userAddress?: Address;
  billingAddress?: Address;
  phone?: string | undefined;
  fax?: string | undefined;
  mobile?: string | undefined;
  registrationCodeGuid?: string | undefined;
  parentUserName?: string | undefined;

  constructor(data?: IUserAccountRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.companyName = _data['companyName'];
      this.abn = _data['abn'];
      this.emailAddress = _data['emailAddress'];
      this.emailConfirmed = _data['emailConfirmed'];
      this.userAddress = _data['userAddress'] ? Address.fromJS(_data['userAddress']) : <any>undefined;
      this.billingAddress = _data['billingAddress'] ? Address.fromJS(_data['billingAddress']) : <any>undefined;
      this.phone = _data['phone'];
      this.fax = _data['fax'];
      this.mobile = _data['mobile'];
      this.registrationCodeGuid = _data['registrationCodeGuid'];
      this.parentUserName = _data['parentUserName'];
    }
  }

  static fromJS(data: any): UserAccountRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserAccountRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['companyName'] = this.companyName;
    data['abn'] = this.abn;
    data['emailAddress'] = this.emailAddress;
    data['emailConfirmed'] = this.emailConfirmed;
    data['userAddress'] = this.userAddress ? this.userAddress.toJSON() : <any>undefined;
    data['billingAddress'] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
    data['phone'] = this.phone;
    data['fax'] = this.fax;
    data['mobile'] = this.mobile;
    data['registrationCodeGuid'] = this.registrationCodeGuid;
    data['parentUserName'] = this.parentUserName;
    return data;
  }
}

export interface IUserAccountRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyName?: string | undefined;
  abn?: string | undefined;
  emailAddress?: string | undefined;
  emailConfirmed?: boolean;
  userAddress?: Address;
  billingAddress?: Address;
  phone?: string | undefined;
  fax?: string | undefined;
  mobile?: string | undefined;
  registrationCodeGuid?: string | undefined;
  parentUserName?: string | undefined;
}

class Address implements IAddress {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;

  constructor(data?: IAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.city = _data['city'];
      this.state = _data['state'];
      this.postcode = _data['postcode'];
    }
  }

  static fromJS(data: any): Address {
    data = typeof data === 'object' ? data : {};
    let result = new Address();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['city'] = this.city;
    data['state'] = this.state;
    data['postcode'] = this.postcode;
    return data;
  }
}

export interface IAddress {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postcode?: string | undefined;
}

export class Ags7SubscriptionRequest implements IAgs7SubscriptionRequest {
  subscriberUserName?: string | undefined;
  planCode?: string | undefined;
  paymentMethodId?: string | undefined;
  abn?: string | undefined;
  entityName?: string | undefined;
  businessName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postCode?: string | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  businessId?: number;
  billingId?: string | undefined;
  subscriptionId?: number | undefined;
  onBehalfOfClient?: boolean;
  files?: string[] | undefined;
  requiresFile?: boolean;
  requiresSetup?: boolean;
  coupon?: string | undefined;
  hasFreeTrial?: boolean;
  prorataStartDate?: Date | undefined;
  childUserId?: number;
  childProfile?: Profile;
  parentSubscriptionId?: number;

  constructor(data?: IAgs7SubscriptionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subscriberUserName = _data['subscriberUserName'];
      this.planCode = _data['planCode'];
      this.paymentMethodId = _data['paymentMethodId'];
      this.abn = _data['abn'];
      this.entityName = _data['entityName'];
      this.businessName = _data['businessName'];
      this.addressLine1 = _data['addressLine1'];
      this.addressLine2 = _data['addressLine2'];
      this.city = _data['city'];
      this.state = _data['state'];
      this.postCode = _data['postCode'];
      this.contactName = _data['contactName'];
      this.contactPhone = _data['contactPhone'];
      this.contactEmail = _data['contactEmail'];
      this.businessId = _data['businessId'];
      this.billingId = _data['billingId'];
      this.subscriptionId = _data['subscriptionId'];
      this.onBehalfOfClient = _data['onBehalfOfClient'];
      if (Array.isArray(_data['files'])) {
        this.files = [] as any;
        for (let item of _data['files']) this.files!.push(item);
      }
      this.requiresFile = _data['requiresFile'];
      this.requiresSetup = _data['requiresSetup'];
      this.coupon = _data['coupon'];
      this.hasFreeTrial = _data['hasFreeTrial'];
      this.prorataStartDate = _data['prorataStartDate'] ? new Date(_data['prorataStartDate'].toString()) : <any>undefined;
      this.childUserId = _data['childUserId'];
      this.childProfile = _data['childProfile'] ? Profile.fromJS(_data['childProfile']) : <any>undefined;
      this.parentSubscriptionId = _data['parentSubscriptionId'];
    }
  }

  static fromJS(data: any): Ags7SubscriptionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new Ags7SubscriptionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['subscriberUserName'] = this.subscriberUserName;
    data['planCode'] = this.planCode;
    data['paymentMethodId'] = this.paymentMethodId;
    data['abn'] = this.abn;
    data['entityName'] = this.entityName;
    data['businessName'] = this.businessName;
    data['addressLine1'] = this.addressLine1;
    data['addressLine2'] = this.addressLine2;
    data['city'] = this.city;
    data['state'] = this.state;
    data['postCode'] = this.postCode;
    data['contactName'] = this.contactName;
    data['contactPhone'] = this.contactPhone;
    data['contactEmail'] = this.contactEmail;
    data['businessId'] = this.businessId;
    data['billingId'] = this.billingId;
    data['subscriptionId'] = this.subscriptionId;
    data['onBehalfOfClient'] = this.onBehalfOfClient;
    if (Array.isArray(this.files)) {
      data['files'] = [];
      for (let item of this.files) data['files'].push(item);
    }
    data['requiresFile'] = this.requiresFile;
    data['requiresSetup'] = this.requiresSetup;
    data['coupon'] = this.coupon;
    data['hasFreeTrial'] = this.hasFreeTrial;
    data['prorataStartDate'] = this.prorataStartDate ? this.prorataStartDate.toISOString() : <any>undefined;
    data['childUserId'] = this.childUserId;
    data['childProfile'] = this.childProfile ? this.childProfile.toJSON() : <any>undefined;
    data['parentSubscriptionId'] = this.parentSubscriptionId;
    return data;
  }
}

export interface IAgs7SubscriptionRequest {
  subscriberUserName?: string | undefined;
  planCode?: string | undefined;
  paymentMethodId?: string | undefined;
  abn?: string | undefined;
  entityName?: string | undefined;
  businessName?: string | undefined;
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postCode?: string | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  businessId?: number;
  billingId?: string | undefined;
  subscriptionId?: number | undefined;
  onBehalfOfClient?: boolean;
  files?: string[] | undefined;
  requiresFile?: boolean;
  requiresSetup?: boolean;
  coupon?: string | undefined;
  hasFreeTrial?: boolean;
  prorataStartDate?: Date | undefined;
  childUserId?: number;
  childProfile?: Profile;
  parentSubscriptionId?: number;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

export class ShopCoupon implements IShopCoupon {
  name?: string | undefined;
  stripeId?: string | undefined;
  amountOff?: number | undefined;
  percentOff?: number | undefined;
  isValid?: boolean;

  constructor(data?: IShopCoupon) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.stripeId = _data['stripeId'];
      this.amountOff = _data['amountOff'];
      this.percentOff = _data['percentOff'];
      this.isValid = _data['isValid'];
    }
  }

  static fromJS(data: any): ShopCoupon {
    data = typeof data === 'object' ? data : {};
    let result = new ShopCoupon();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['stripeId'] = this.stripeId;
    data['amountOff'] = this.amountOff;
    data['percentOff'] = this.percentOff;
    data['isValid'] = this.isValid;
    return data;
  }
}

export interface IShopCoupon {
  name?: string | undefined;
  stripeId?: string | undefined;
  amountOff?: number | undefined;
  percentOff?: number | undefined;
  isValid?: boolean;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
